import * as i0 from '@angular/core';
import { Injectable, inject } from '@angular/core';
import { throwError, of } from 'rxjs';
import { map, mapTo } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var CalendarSource = /*#__PURE__*/function (CalendarSource) {
  CalendarSource[CalendarSource["CALENDAR_SOURCE_GOOGLE"] = 0] = "CALENDAR_SOURCE_GOOGLE";
  CalendarSource[CalendarSource["CALENDAR_SOURCE_MICROSOFT"] = 1] = "CALENDAR_SOURCE_MICROSOFT";
  CalendarSource[CalendarSource["CALENDAR_SOURCE_INVALID"] = -1] = "CALENDAR_SOURCE_INVALID";
  return CalendarSource;
}(CalendarSource || {});
var MeetingSource = /*#__PURE__*/function (MeetingSource) {
  MeetingSource[MeetingSource["MEETING_SOURCE_INVALID"] = 0] = "MEETING_SOURCE_INVALID";
  MeetingSource[MeetingSource["MEETING_SOURCE_ZOOM"] = 1] = "MEETING_SOURCE_ZOOM";
  MeetingSource[MeetingSource["MEETING_SOURCE_GOOGLE_MEET"] = 2] = "MEETING_SOURCE_GOOGLE_MEET";
  MeetingSource[MeetingSource["MEETING_SOURCE_MICROSOFT"] = 3] = "MEETING_SOURCE_MICROSOFT";
  return MeetingSource;
}(MeetingSource || {});
var MeetingSourceStatus = /*#__PURE__*/function (MeetingSourceStatus) {
  MeetingSourceStatus[MeetingSourceStatus["MEETING_SOURCE_STATUS_INVALID"] = 0] = "MEETING_SOURCE_STATUS_INVALID";
  MeetingSourceStatus[MeetingSourceStatus["MEETING_SOURCE_STATUS_CONNECTED"] = 1] = "MEETING_SOURCE_STATUS_CONNECTED";
  MeetingSourceStatus[MeetingSourceStatus["MEETING_SOURCE_STATUS_DISCONNECTED"] = 2] = "MEETING_SOURCE_STATUS_DISCONNECTED";
  MeetingSourceStatus[MeetingSourceStatus["MEETING_SOURCE_STATUS_BROKEN"] = 3] = "MEETING_SOURCE_STATUS_BROKEN";
  return MeetingSourceStatus;
}(MeetingSourceStatus || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ZoomApprovalType = /*#__PURE__*/function (ZoomApprovalType) {
  ZoomApprovalType[ZoomApprovalType["ZOOM_APPROVAL_TYPE_INVALID"] = 0] = "ZOOM_APPROVAL_TYPE_INVALID";
  ZoomApprovalType[ZoomApprovalType["ZOOM_APPROVAL_TYPE_ATUO_APPROVE"] = 1] = "ZOOM_APPROVAL_TYPE_ATUO_APPROVE";
  ZoomApprovalType[ZoomApprovalType["ZOOM_APPROVAL_TYPE_MANUALLY_APPROVE"] = 2] = "ZOOM_APPROVAL_TYPE_MANUALLY_APPROVE";
  ZoomApprovalType[ZoomApprovalType["ZOOM_APPROVAL_TYPE_NO_REGISTRATION_REQUIRED"] = 3] = "ZOOM_APPROVAL_TYPE_NO_REGISTRATION_REQUIRED";
  return ZoomApprovalType;
}(ZoomApprovalType || {});
var ZoomMeetingRecurrenceType = /*#__PURE__*/function (ZoomMeetingRecurrenceType) {
  ZoomMeetingRecurrenceType[ZoomMeetingRecurrenceType["ZOOM_MEETING_RECURRENCE_TYPE_INVALID"] = 0] = "ZOOM_MEETING_RECURRENCE_TYPE_INVALID";
  ZoomMeetingRecurrenceType[ZoomMeetingRecurrenceType["ZOOM_MEETING_RECURRENCE_TYPE_DAILY"] = 1] = "ZOOM_MEETING_RECURRENCE_TYPE_DAILY";
  ZoomMeetingRecurrenceType[ZoomMeetingRecurrenceType["ZOOM_MEETING_RECURRENCE_TYPE_WEEKLY"] = 2] = "ZOOM_MEETING_RECURRENCE_TYPE_WEEKLY";
  ZoomMeetingRecurrenceType[ZoomMeetingRecurrenceType["ZOOM_MEETING_RECURRENCE_TYPE_MONTHLY"] = 3] = "ZOOM_MEETING_RECURRENCE_TYPE_MONTHLY";
  return ZoomMeetingRecurrenceType;
}(ZoomMeetingRecurrenceType || {});
var ZoomMeetingType = /*#__PURE__*/function (ZoomMeetingType) {
  ZoomMeetingType[ZoomMeetingType["ZOOM_MEETING_TYPE_INVALID"] = 0] = "ZOOM_MEETING_TYPE_INVALID";
  ZoomMeetingType[ZoomMeetingType["ZOOM_MEETING_TYPE_INSTANT"] = 1] = "ZOOM_MEETING_TYPE_INSTANT";
  ZoomMeetingType[ZoomMeetingType["ZOOM_MEETING_TYPE_SCHEDULED"] = 2] = "ZOOM_MEETING_TYPE_SCHEDULED";
  ZoomMeetingType[ZoomMeetingType["ZOOM_MEETING_TYPE_RECURRING_NO_FIXED"] = 3] = "ZOOM_MEETING_TYPE_RECURRING_NO_FIXED";
  ZoomMeetingType[ZoomMeetingType["ZOOM_MEETING_TYPE_RECURRING_FIXED"] = 8] = "ZOOM_MEETING_TYPE_RECURRING_FIXED";
  return ZoomMeetingType;
}(ZoomMeetingType || {});
var ZoomMonthlyWeek = /*#__PURE__*/function (ZoomMonthlyWeek) {
  ZoomMonthlyWeek[ZoomMonthlyWeek["ZOOM_MONTHLY_WEEK_INVALD"] = 0] = "ZOOM_MONTHLY_WEEK_INVALD";
  ZoomMonthlyWeek[ZoomMonthlyWeek["ZOOM_MONTHLY_WEEK_LAST_WEEK"] = -1] = "ZOOM_MONTHLY_WEEK_LAST_WEEK";
  ZoomMonthlyWeek[ZoomMonthlyWeek["ZOOM_MONTHLY_WEEK_FIRST_WEEK"] = 1] = "ZOOM_MONTHLY_WEEK_FIRST_WEEK";
  ZoomMonthlyWeek[ZoomMonthlyWeek["ZOOM_MONTHLY_WEEK_SECOND_WEEK"] = 2] = "ZOOM_MONTHLY_WEEK_SECOND_WEEK";
  ZoomMonthlyWeek[ZoomMonthlyWeek["ZOOM_MONTHLY_WEEK_THIRD_WEEK"] = 3] = "ZOOM_MONTHLY_WEEK_THIRD_WEEK";
  ZoomMonthlyWeek[ZoomMonthlyWeek["ZOOM_MONTHLY_WEEK_FOURTH_WEEK"] = 4] = "ZOOM_MONTHLY_WEEK_FOURTH_WEEK";
  return ZoomMonthlyWeek;
}(ZoomMonthlyWeek || {});
var ZoomMonthlyWeekDay = /*#__PURE__*/function (ZoomMonthlyWeekDay) {
  ZoomMonthlyWeekDay[ZoomMonthlyWeekDay["ZOOM_MONTHLY_WEEK_DAY_INVALID"] = 0] = "ZOOM_MONTHLY_WEEK_DAY_INVALID";
  ZoomMonthlyWeekDay[ZoomMonthlyWeekDay["ZOOM_MONTHLY_WEEK_DAY_SUNDAY"] = 1] = "ZOOM_MONTHLY_WEEK_DAY_SUNDAY";
  ZoomMonthlyWeekDay[ZoomMonthlyWeekDay["ZOOM_MONTHLY_WEEK_DAY_MONDAY"] = 2] = "ZOOM_MONTHLY_WEEK_DAY_MONDAY";
  ZoomMonthlyWeekDay[ZoomMonthlyWeekDay["ZOOM_MONTHLY_WEEK_DAY_TUESDAY"] = 3] = "ZOOM_MONTHLY_WEEK_DAY_TUESDAY";
  ZoomMonthlyWeekDay[ZoomMonthlyWeekDay["ZOOM_MONTHLY_WEEK_DAY_WEDNESDAY"] = 4] = "ZOOM_MONTHLY_WEEK_DAY_WEDNESDAY";
  ZoomMonthlyWeekDay[ZoomMonthlyWeekDay["ZOOM_MONTHLY_WEEK_DAY_THURSDAY"] = 5] = "ZOOM_MONTHLY_WEEK_DAY_THURSDAY";
  ZoomMonthlyWeekDay[ZoomMonthlyWeekDay["ZOOM_MONTHLY_WEEK_DAY_FRIDAY"] = 6] = "ZOOM_MONTHLY_WEEK_DAY_FRIDAY";
  ZoomMonthlyWeekDay[ZoomMonthlyWeekDay["ZOOM_MONTHLY_WEEK_DAY_SATURDAY"] = 7] = "ZOOM_MONTHLY_WEEK_DAY_SATURDAY";
  return ZoomMonthlyWeekDay;
}(ZoomMonthlyWeekDay || {});
var ZoomRegistrationType = /*#__PURE__*/function (ZoomRegistrationType) {
  ZoomRegistrationType[ZoomRegistrationType["ZOOM_REGISTRATION_TYPE_INVALID"] = 0] = "ZOOM_REGISTRATION_TYPE_INVALID";
  ZoomRegistrationType[ZoomRegistrationType["ZOOM_REGISTRATION_TYPE_RESGITER_ONCE_FOR_ALL"] = 1] = "ZOOM_REGISTRATION_TYPE_RESGITER_ONCE_FOR_ALL";
  ZoomRegistrationType[ZoomRegistrationType["ZOOM_REGISTRATION_TYPE_REGISTER_FOR_EACH"] = 2] = "ZOOM_REGISTRATION_TYPE_REGISTER_FOR_EACH";
  ZoomRegistrationType[ZoomRegistrationType["ZOOM_REGISTRATION_TYPE_RESGITER_ONCE_FOR_ONE_OR_MORE"] = 3] = "ZOOM_REGISTRATION_TYPE_RESGITER_ONCE_FOR_ONE_OR_MORE";
  return ZoomRegistrationType;
}(ZoomRegistrationType || {});
var ZoomWeeklyDay = /*#__PURE__*/function (ZoomWeeklyDay) {
  ZoomWeeklyDay[ZoomWeeklyDay["ZOOM_WEEKLY_DAY_INVALID"] = 0] = "ZOOM_WEEKLY_DAY_INVALID";
  ZoomWeeklyDay[ZoomWeeklyDay["ZOOM_WEEKLY_DAY_SUNDAY"] = 1] = "ZOOM_WEEKLY_DAY_SUNDAY";
  ZoomWeeklyDay[ZoomWeeklyDay["ZOOM_WEEKLY_DAY_MONDAY"] = 2] = "ZOOM_WEEKLY_DAY_MONDAY";
  ZoomWeeklyDay[ZoomWeeklyDay["ZOOM_WEEKLY_DAY_TUESDAY"] = 3] = "ZOOM_WEEKLY_DAY_TUESDAY";
  ZoomWeeklyDay[ZoomWeeklyDay["ZOOM_WEEKLY_DAY_WEDNESDAY"] = 4] = "ZOOM_WEEKLY_DAY_WEDNESDAY";
  ZoomWeeklyDay[ZoomWeeklyDay["ZOOM_WEEKLY_DAY_THURSDAY"] = 5] = "ZOOM_WEEKLY_DAY_THURSDAY";
  ZoomWeeklyDay[ZoomWeeklyDay["ZOOM_WEEKLY_DAY_FRIDAY"] = 6] = "ZOOM_WEEKLY_DAY_FRIDAY";
  ZoomWeeklyDay[ZoomWeeklyDay["ZOOM_WEEKLY_DAY_SATURDAY"] = 7] = "ZOOM_WEEKLY_DAY_SATURDAY";
  return ZoomWeeklyDay;
}(ZoomWeeklyDay || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var CalendarType = /*#__PURE__*/function (CalendarType) {
  CalendarType[CalendarType["CALENDAR_TYPE_INVALID"] = 0] = "CALENDAR_TYPE_INVALID";
  CalendarType[CalendarType["CALENDAR_TYPE_PERSONAL"] = 1] = "CALENDAR_TYPE_PERSONAL";
  CalendarType[CalendarType["CALENDAR_TYPE_GROUP"] = 2] = "CALENDAR_TYPE_GROUP";
  CalendarType[CalendarType["CALENDAR_TYPE_SESSION"] = 3] = "CALENDAR_TYPE_SESSION";
  return CalendarType;
}(CalendarType || {});
var FormFieldType = /*#__PURE__*/function (FormFieldType) {
  FormFieldType[FormFieldType["FORM_FIELD_TYPE_INVALID"] = 0] = "FORM_FIELD_TYPE_INVALID";
  FormFieldType[FormFieldType["FORM_FIELD_TYPE_TEXT"] = 1] = "FORM_FIELD_TYPE_TEXT";
  FormFieldType[FormFieldType["FORM_FIELD_TYPE_EMAIL"] = 2] = "FORM_FIELD_TYPE_EMAIL";
  FormFieldType[FormFieldType["FORM_FIELD_TYPE_PHONE_NUMBER"] = 3] = "FORM_FIELD_TYPE_PHONE_NUMBER";
  FormFieldType[FormFieldType["FORM_FIELD_TYPE_SELECT"] = 4] = "FORM_FIELD_TYPE_SELECT";
  return FormFieldType;
}(FormFieldType || {});
var OnBoardingState = /*#__PURE__*/function (OnBoardingState) {
  OnBoardingState[OnBoardingState["COMPLETED_SETUP"] = 0] = "COMPLETED_SETUP";
  OnBoardingState[OnBoardingState["NOT_YET_STARTED"] = 1] = "NOT_YET_STARTED";
  OnBoardingState[OnBoardingState["SLUG_CREATED"] = 2] = "SLUG_CREATED";
  OnBoardingState[OnBoardingState["CALENDAR_CONNECTED"] = 3] = "CALENDAR_CONNECTED";
  OnBoardingState[OnBoardingState["MEETING_APP_CONNECTED"] = 4] = "MEETING_APP_CONNECTED";
  return OnBoardingState;
}(OnBoardingState || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var DateRangeType = /*#__PURE__*/function (DateRangeType) {
  DateRangeType[DateRangeType["RELATIVE"] = 0] = "RELATIVE";
  DateRangeType[DateRangeType["CUSTOM"] = 1] = "CUSTOM";
  return DateRangeType;
}(DateRangeType || {});
var MeetingLocationType = /*#__PURE__*/function (MeetingLocationType) {
  MeetingLocationType[MeetingLocationType["VIDEO"] = 0] = "VIDEO";
  MeetingLocationType[MeetingLocationType["IN_PERSON_USER_SITE"] = 1] = "IN_PERSON_USER_SITE";
  MeetingLocationType[MeetingLocationType["IN_PERSON_CLIENT_SITE"] = 2] = "IN_PERSON_CLIENT_SITE";
  return MeetingLocationType;
}(MeetingLocationType || {});
var RegistrationCutOffUnit = /*#__PURE__*/function (RegistrationCutOffUnit) {
  RegistrationCutOffUnit[RegistrationCutOffUnit["REGISTRATION_CUTOFF_DAYS"] = 0] = "REGISTRATION_CUTOFF_DAYS";
  RegistrationCutOffUnit[RegistrationCutOffUnit["REGISTRATION_CUTOFF_HOURS"] = 1] = "REGISTRATION_CUTOFF_HOURS";
  RegistrationCutOffUnit[RegistrationCutOffUnit["REGISTRATION_CUTOFF_MINUTES"] = 2] = "REGISTRATION_CUTOFF_MINUTES";
  return RegistrationCutOffUnit;
}(RegistrationCutOffUnit || {});
var RelativeTimeUnit = /*#__PURE__*/function (RelativeTimeUnit) {
  RelativeTimeUnit[RelativeTimeUnit["DAYS"] = 0] = "DAYS";
  RelativeTimeUnit[RelativeTimeUnit["WEEKS"] = 1] = "WEEKS";
  RelativeTimeUnit[RelativeTimeUnit["MONTHS"] = 2] = "MONTHS";
  return RelativeTimeUnit;
}(RelativeTimeUnit || {});
var TeamEventMeetingType = /*#__PURE__*/function (TeamEventMeetingType) {
  TeamEventMeetingType[TeamEventMeetingType["ROUND_ROBIN"] = 0] = "ROUND_ROBIN";
  TeamEventMeetingType[TeamEventMeetingType["CLIENT_CHOICE"] = 1] = "CLIENT_CHOICE";
  TeamEventMeetingType[TeamEventMeetingType["MULTI_HOST"] = 2] = "MULTI_HOST";
  TeamEventMeetingType[TeamEventMeetingType["PRIORITY_ROUND_ROBIN"] = 3] = "PRIORITY_ROUND_ROBIN";
  return TeamEventMeetingType;
}(TeamEventMeetingType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var DayOfWeek = /*#__PURE__*/function (DayOfWeek) {
  DayOfWeek[DayOfWeek["DAY_OF_WEEK_UNSPECIFIED"] = 0] = "DAY_OF_WEEK_UNSPECIFIED";
  DayOfWeek[DayOfWeek["MONDAY"] = 1] = "MONDAY";
  DayOfWeek[DayOfWeek["TUESDAY"] = 2] = "TUESDAY";
  DayOfWeek[DayOfWeek["WEDNESDAY"] = 3] = "WEDNESDAY";
  DayOfWeek[DayOfWeek["THURSDAY"] = 4] = "THURSDAY";
  DayOfWeek[DayOfWeek["FRIDAY"] = 5] = "FRIDAY";
  DayOfWeek[DayOfWeek["SATURDAY"] = 6] = "SATURDAY";
  DayOfWeek[DayOfWeek["SUNDAY"] = 7] = "SUNDAY";
  return DayOfWeek;
}(DayOfWeek || {});
// *********************************

function enumStringToValue$b(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class MeetingSourceInfo {
  static fromProto(proto) {
    let m = new MeetingSourceInfo();
    m = Object.assign(m, proto);
    if (proto.source) {
      m.source = enumStringToValue$b(MeetingSource, proto.source);
    }
    if (proto.status) {
      m.status = enumStringToValue$b(MeetingSourceStatus, proto.status);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.source !== 'undefined') {
      toReturn['source'] = this.source;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.connectDisconnectUrl !== 'undefined') {
      toReturn['connectDisconnectUrl'] = this.connectDisconnectUrl;
    }
    if (typeof this.connectionLabel !== 'undefined') {
      toReturn['connectionLabel'] = this.connectionLabel;
    }
    return toReturn;
  }
}
class MeetingSourceListRequest {
  static fromProto(proto) {
    let m = new MeetingSourceListRequest();
    m = Object.assign(m, proto);
    if (proto.queriedSources) {
      m.queriedSources = proto.queriedSources.map(MeetingSourceQuery.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.iamUserId !== 'undefined') {
      toReturn['iamUserId'] = this.iamUserId;
    }
    if (typeof this.queriedSources !== 'undefined' && this.queriedSources !== null) {
      toReturn['queriedSources'] = 'toApiJson' in this.queriedSources ? this.queriedSources.toApiJson() : this.queriedSources;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.origin !== 'undefined') {
      toReturn['origin'] = this.origin;
    }
    return toReturn;
  }
}
class MeetingSourceListResponse {
  static fromProto(proto) {
    let m = new MeetingSourceListResponse();
    m = Object.assign(m, proto);
    if (proto.sourceInfo) {
      m.sourceInfo = proto.sourceInfo.map(MeetingSourceInfo.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.iamUserId !== 'undefined') {
      toReturn['iamUserId'] = this.iamUserId;
    }
    if (typeof this.sourceInfo !== 'undefined' && this.sourceInfo !== null) {
      toReturn['sourceInfo'] = 'toApiJson' in this.sourceInfo ? this.sourceInfo.toApiJson() : this.sourceInfo;
    }
    return toReturn;
  }
}
class MeetingSourceQuery {
  static fromProto(proto) {
    let m = new MeetingSourceQuery();
    m = Object.assign(m, proto);
    if (proto.source) {
      m.source = enumStringToValue$b(MeetingSource, proto.source);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.source !== 'undefined') {
      toReturn['source'] = this.source;
    }
    if (typeof this.connectNextUrl !== 'undefined') {
      toReturn['connectNextUrl'] = this.connectNextUrl;
    }
    if (typeof this.disconnectNextUrl !== 'undefined') {
      toReturn['disconnectNextUrl'] = this.disconnectNextUrl;
    }
    return toReturn;
  }
}
function enumStringToValue$a(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CreateZoomMeetingRequest {
  static fromProto(proto) {
    let m = new CreateZoomMeetingRequest();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue$a(ZoomMeetingType, proto.type);
    }
    if (proto.duration) {
      m.duration = parseInt(proto.duration, 10);
    }
    if (proto.trackingFields) {
      m.trackingFields = proto.trackingFields.map(ZoomMeetingTrackingField.fromProto);
    }
    if (proto.recurrence) {
      m.recurrence = ZoomMeetingRecurrence.fromProto(proto.recurrence);
    }
    if (proto.settings) {
      m.settings = ZoomMeetingSettings.fromProto(proto.settings);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.iamUserId !== 'undefined') {
      toReturn['iamUserId'] = this.iamUserId;
    }
    if (typeof this.topic !== 'undefined') {
      toReturn['topic'] = this.topic;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.startTime !== 'undefined') {
      toReturn['startTime'] = this.startTime;
    }
    if (typeof this.duration !== 'undefined') {
      toReturn['duration'] = this.duration;
    }
    if (typeof this.timezone !== 'undefined') {
      toReturn['timezone'] = this.timezone;
    }
    if (typeof this.password !== 'undefined') {
      toReturn['password'] = this.password;
    }
    if (typeof this.agenda !== 'undefined') {
      toReturn['agenda'] = this.agenda;
    }
    if (typeof this.trackingFields !== 'undefined' && this.trackingFields !== null) {
      toReturn['trackingFields'] = 'toApiJson' in this.trackingFields ? this.trackingFields.toApiJson() : this.trackingFields;
    }
    if (typeof this.recurrence !== 'undefined' && this.recurrence !== null) {
      toReturn['recurrence'] = 'toApiJson' in this.recurrence ? this.recurrence.toApiJson() : this.recurrence;
    }
    if (typeof this.settings !== 'undefined' && this.settings !== null) {
      toReturn['settings'] = 'toApiJson' in this.settings ? this.settings.toApiJson() : this.settings;
    }
    return toReturn;
  }
}
class CreateZoomMeetingResponse {
  static fromProto(proto) {
    let m = new CreateZoomMeetingResponse();
    m = Object.assign(m, proto);
    if (proto.meetingId) {
      m.meetingId = parseInt(proto.meetingId, 10);
    }
    if (proto.type) {
      m.type = enumStringToValue$a(ZoomMeetingType, proto.type);
    }
    if (proto.duration) {
      m.duration = parseInt(proto.duration, 10);
    }
    if (proto.pmi) {
      m.pmi = parseInt(proto.pmi, 10);
    }
    if (proto.trackingFields) {
      m.trackingFields = proto.trackingFields.map(ZoomMeetingTrackingField.fromProto);
    }
    if (proto.occurrences) {
      m.occurrences = proto.occurrences.map(ZoomOccurrence.fromProto);
    }
    if (proto.settings) {
      m.settings = ZoomMeetingSettings.fromProto(proto.settings);
    }
    if (proto.recurrence) {
      m.recurrence = ZoomMeetingRecurrence.fromProto(proto.recurrence);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.iamUserId !== 'undefined') {
      toReturn['iamUserId'] = this.iamUserId;
    }
    if (typeof this.meetingId !== 'undefined') {
      toReturn['meetingId'] = this.meetingId;
    }
    if (typeof this.topic !== 'undefined') {
      toReturn['topic'] = this.topic;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.startTime !== 'undefined') {
      toReturn['startTime'] = this.startTime;
    }
    if (typeof this.duration !== 'undefined') {
      toReturn['duration'] = this.duration;
    }
    if (typeof this.timezone !== 'undefined') {
      toReturn['timezone'] = this.timezone;
    }
    if (typeof this.createdAt !== 'undefined') {
      toReturn['createdAt'] = this.createdAt;
    }
    if (typeof this.agenda !== 'undefined') {
      toReturn['agenda'] = this.agenda;
    }
    if (typeof this.startUrl !== 'undefined') {
      toReturn['startUrl'] = this.startUrl;
    }
    if (typeof this.joinUrl !== 'undefined') {
      toReturn['joinUrl'] = this.joinUrl;
    }
    if (typeof this.password !== 'undefined') {
      toReturn['password'] = this.password;
    }
    if (typeof this.h323Password !== 'undefined') {
      toReturn['h323Password'] = this.h323Password;
    }
    if (typeof this.pmi !== 'undefined') {
      toReturn['pmi'] = this.pmi;
    }
    if (typeof this.trackingFields !== 'undefined' && this.trackingFields !== null) {
      toReturn['trackingFields'] = 'toApiJson' in this.trackingFields ? this.trackingFields.toApiJson() : this.trackingFields;
    }
    if (typeof this.occurrences !== 'undefined' && this.occurrences !== null) {
      toReturn['occurrences'] = 'toApiJson' in this.occurrences ? this.occurrences.toApiJson() : this.occurrences;
    }
    if (typeof this.settings !== 'undefined' && this.settings !== null) {
      toReturn['settings'] = 'toApiJson' in this.settings ? this.settings.toApiJson() : this.settings;
    }
    if (typeof this.recurrence !== 'undefined' && this.recurrence !== null) {
      toReturn['recurrence'] = 'toApiJson' in this.recurrence ? this.recurrence.toApiJson() : this.recurrence;
    }
    return toReturn;
  }
}
class ZoomMeetingRecurrence {
  static fromProto(proto) {
    let m = new ZoomMeetingRecurrence();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue$a(ZoomMeetingRecurrenceType, proto.type);
    }
    if (proto.repeatInterval) {
      m.repeatInterval = parseInt(proto.repeatInterval, 10);
    }
    if (proto.monthlyDay) {
      m.monthlyDay = parseInt(proto.monthlyDay, 10);
    }
    if (proto.monthlyWeek) {
      m.monthlyWeek = enumStringToValue$a(ZoomMonthlyWeek, proto.monthlyWeek);
    }
    if (proto.monthlyWeekDay) {
      m.monthlyWeekDay = enumStringToValue$a(ZoomMonthlyWeekDay, proto.monthlyWeekDay);
    }
    if (proto.endTimes) {
      m.endTimes = parseInt(proto.endTimes, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.repeatInterval !== 'undefined') {
      toReturn['repeatInterval'] = this.repeatInterval;
    }
    if (typeof this.weeklyDays !== 'undefined') {
      toReturn['weeklyDays'] = this.weeklyDays;
    }
    if (typeof this.monthlyDay !== 'undefined') {
      toReturn['monthlyDay'] = this.monthlyDay;
    }
    if (typeof this.monthlyWeek !== 'undefined') {
      toReturn['monthlyWeek'] = this.monthlyWeek;
    }
    if (typeof this.monthlyWeekDay !== 'undefined') {
      toReturn['monthlyWeekDay'] = this.monthlyWeekDay;
    }
    if (typeof this.endTimes !== 'undefined') {
      toReturn['endTimes'] = this.endTimes;
    }
    if (typeof this.endDateTime !== 'undefined') {
      toReturn['endDateTime'] = this.endDateTime;
    }
    return toReturn;
  }
}
class ZoomMeetingSettings {
  static fromProto(proto) {
    let m = new ZoomMeetingSettings();
    m = Object.assign(m, proto);
    if (proto.approvalType) {
      m.approvalType = enumStringToValue$a(ZoomApprovalType, proto.approvalType);
    }
    if (proto.registrationType) {
      m.registrationType = enumStringToValue$a(ZoomRegistrationType, proto.registrationType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hostVideo !== 'undefined') {
      toReturn['hostVideo'] = this.hostVideo;
    }
    if (typeof this.participantVideo !== 'undefined') {
      toReturn['participantVideo'] = this.participantVideo;
    }
    if (typeof this.cnMeeting !== 'undefined') {
      toReturn['cnMeeting'] = this.cnMeeting;
    }
    if (typeof this.inMeeting !== 'undefined') {
      toReturn['inMeeting'] = this.inMeeting;
    }
    if (typeof this.joinBeforeHost !== 'undefined') {
      toReturn['joinBeforeHost'] = this.joinBeforeHost;
    }
    if (typeof this.muteUponEntry !== 'undefined') {
      toReturn['muteUponEntry'] = this.muteUponEntry;
    }
    if (typeof this.watermark !== 'undefined') {
      toReturn['watermark'] = this.watermark;
    }
    if (typeof this.usePmi !== 'undefined') {
      toReturn['usePmi'] = this.usePmi;
    }
    if (typeof this.approvalType !== 'undefined') {
      toReturn['approvalType'] = this.approvalType;
    }
    if (typeof this.registrationType !== 'undefined') {
      toReturn['registrationType'] = this.registrationType;
    }
    if (typeof this.audio !== 'undefined') {
      toReturn['audio'] = this.audio;
    }
    if (typeof this.autoRecording !== 'undefined') {
      toReturn['autoRecording'] = this.autoRecording;
    }
    if (typeof this.alternativeHosts !== 'undefined') {
      toReturn['alternativeHosts'] = this.alternativeHosts;
    }
    if (typeof this.closeRegistration !== 'undefined') {
      toReturn['closeRegistration'] = this.closeRegistration;
    }
    if (typeof this.waitingRoom !== 'undefined') {
      toReturn['waitingRoom'] = this.waitingRoom;
    }
    if (typeof this.globalDialInCountries !== 'undefined') {
      toReturn['globalDialInCountries'] = this.globalDialInCountries;
    }
    if (typeof this.contactName !== 'undefined') {
      toReturn['contactName'] = this.contactName;
    }
    if (typeof this.contactEmail !== 'undefined') {
      toReturn['contactEmail'] = this.contactEmail;
    }
    if (typeof this.registrationEmailNotification !== 'undefined') {
      toReturn['registrationEmailNotification'] = this.registrationEmailNotification;
    }
    if (typeof this.meetingAuthentication !== 'undefined') {
      toReturn['meetingAuthentication'] = this.meetingAuthentication;
    }
    if (typeof this.authenticationOptions !== 'undefined') {
      toReturn['authenticationOptions'] = this.authenticationOptions;
    }
    if (typeof this.authenticationDomains !== 'undefined') {
      toReturn['authenticationDomains'] = this.authenticationDomains;
    }
    if (typeof this.enforceLogin !== 'undefined') {
      toReturn['enforceLogin'] = this.enforceLogin;
    }
    if (typeof this.enforceLoginDomains !== 'undefined') {
      toReturn['enforceLoginDomains'] = this.enforceLoginDomains;
    }
    return toReturn;
  }
}
class ZoomMeetingTrackingField {
  static fromProto(proto) {
    let m = new ZoomMeetingTrackingField();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.field !== 'undefined') {
      toReturn['field'] = this.field;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class ZoomOccurrence {
  static fromProto(proto) {
    let m = new ZoomOccurrence();
    m = Object.assign(m, proto);
    if (proto.duration) {
      m.duration = parseInt(proto.duration, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.occurrenceId !== 'undefined') {
      toReturn['occurrenceId'] = this.occurrenceId;
    }
    if (typeof this.startTime !== 'undefined') {
      toReturn['startTime'] = this.startTime;
    }
    if (typeof this.duration !== 'undefined') {
      toReturn['duration'] = this.duration;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    return toReturn;
  }
}
function enumStringToValue$9(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class GoogleMeetConferenceData {
  static fromProto(proto) {
    let m = new GoogleMeetConferenceData();
    m = Object.assign(m, proto);
    if (proto.conferenceSolution) {
      m.conferenceSolution = GoogleMeetConferenceSolution.fromProto(proto.conferenceSolution);
    }
    if (proto.createRequest) {
      m.createRequest = GoogleMeetCreateConferenceRequest.fromProto(proto.createRequest);
    }
    if (proto.entryPoints) {
      m.entryPoints = proto.entryPoints.map(GoogleMeetEntryPoint.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.conferenceId !== 'undefined') {
      toReturn['conferenceId'] = this.conferenceId;
    }
    if (typeof this.conferenceSolution !== 'undefined' && this.conferenceSolution !== null) {
      toReturn['conferenceSolution'] = 'toApiJson' in this.conferenceSolution ? this.conferenceSolution.toApiJson() : this.conferenceSolution;
    }
    if (typeof this.createRequest !== 'undefined' && this.createRequest !== null) {
      toReturn['createRequest'] = 'toApiJson' in this.createRequest ? this.createRequest.toApiJson() : this.createRequest;
    }
    if (typeof this.entryPoints !== 'undefined' && this.entryPoints !== null) {
      toReturn['entryPoints'] = 'toApiJson' in this.entryPoints ? this.entryPoints.toApiJson() : this.entryPoints;
    }
    if (typeof this.notes !== 'undefined') {
      toReturn['notes'] = this.notes;
    }
    if (typeof this.signature !== 'undefined') {
      toReturn['signature'] = this.signature;
    }
    return toReturn;
  }
}
class GoogleMeetConferenceRequestStatus {
  static fromProto(proto) {
    let m = new GoogleMeetConferenceRequestStatus();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.statusCode !== 'undefined') {
      toReturn['statusCode'] = this.statusCode;
    }
    return toReturn;
  }
}
class GoogleMeetConferenceSolution {
  static fromProto(proto) {
    let m = new GoogleMeetConferenceSolution();
    m = Object.assign(m, proto);
    if (proto.key) {
      m.key = GoogleMeetConferenceSolutionKey.fromProto(proto.key);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.iconUri !== 'undefined') {
      toReturn['iconUri'] = this.iconUri;
    }
    if (typeof this.key !== 'undefined' && this.key !== null) {
      toReturn['key'] = 'toApiJson' in this.key ? this.key.toApiJson() : this.key;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class GoogleMeetConferenceSolutionKey {
  static fromProto(proto) {
    let m = new GoogleMeetConferenceSolutionKey();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    return toReturn;
  }
}
class GoogleMeetCreateConferenceRequest {
  static fromProto(proto) {
    let m = new GoogleMeetCreateConferenceRequest();
    m = Object.assign(m, proto);
    if (proto.conferenceSolutionKey) {
      m.conferenceSolutionKey = GoogleMeetConferenceSolutionKey.fromProto(proto.conferenceSolutionKey);
    }
    if (proto.status) {
      m.status = GoogleMeetConferenceRequestStatus.fromProto(proto.status);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.conferenceSolutionKey !== 'undefined' && this.conferenceSolutionKey !== null) {
      toReturn['conferenceSolutionKey'] = 'toApiJson' in this.conferenceSolutionKey ? this.conferenceSolutionKey.toApiJson() : this.conferenceSolutionKey;
    }
    if (typeof this.requestId !== 'undefined') {
      toReturn['requestId'] = this.requestId;
    }
    if (typeof this.status !== 'undefined' && this.status !== null) {
      toReturn['status'] = 'toApiJson' in this.status ? this.status.toApiJson() : this.status;
    }
    return toReturn;
  }
}
class GoogleMeetCreateMeetingRequest {
  static fromProto(proto) {
    let m = new GoogleMeetCreateMeetingRequest();
    m = Object.assign(m, proto);
    if (proto.meeting) {
      m.meeting = GoogleMeetMeeting.fromProto(proto.meeting);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.calenderId !== 'undefined') {
      toReturn['calenderId'] = this.calenderId;
    }
    if (typeof this.meeting !== 'undefined' && this.meeting !== null) {
      toReturn['meeting'] = 'toApiJson' in this.meeting ? this.meeting.toApiJson() : this.meeting;
    }
    return toReturn;
  }
}
class GoogleMeetCreateMeetingResponse {
  static fromProto(proto) {
    let m = new GoogleMeetCreateMeetingResponse();
    m = Object.assign(m, proto);
    if (proto.meeting) {
      m.meeting = GoogleMeetMeeting.fromProto(proto.meeting);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.iamUserId !== 'undefined') {
      toReturn['iamUserId'] = this.iamUserId;
    }
    if (typeof this.calenderId !== 'undefined') {
      toReturn['calenderId'] = this.calenderId;
    }
    if (typeof this.meeting !== 'undefined' && this.meeting !== null) {
      toReturn['meeting'] = 'toApiJson' in this.meeting ? this.meeting.toApiJson() : this.meeting;
    }
    return toReturn;
  }
}
class GoogleMeetEntryPoint {
  static fromProto(proto) {
    let m = new GoogleMeetEntryPoint();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accessCode !== 'undefined') {
      toReturn['accessCode'] = this.accessCode;
    }
    if (typeof this.entryPointFeatures !== 'undefined') {
      toReturn['entryPointFeatures'] = this.entryPointFeatures;
    }
    if (typeof this.entryPointType !== 'undefined') {
      toReturn['entryPointType'] = this.entryPointType;
    }
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.meetingCode !== 'undefined') {
      toReturn['meetingCode'] = this.meetingCode;
    }
    if (typeof this.passcode !== 'undefined') {
      toReturn['passcode'] = this.passcode;
    }
    if (typeof this.password !== 'undefined') {
      toReturn['password'] = this.password;
    }
    if (typeof this.pin !== 'undefined') {
      toReturn['pin'] = this.pin;
    }
    if (typeof this.regionCode !== 'undefined') {
      toReturn['regionCode'] = this.regionCode;
    }
    if (typeof this.uri !== 'undefined') {
      toReturn['uri'] = this.uri;
    }
    return toReturn;
  }
}
class GoogleMeetListMeetingsRequest {
  static fromProto(proto) {
    let m = new GoogleMeetListMeetingsRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.timeMin) {
      m.timeMin = new Date(proto.timeMin);
    }
    if (proto.timeMax) {
      m.timeMax = new Date(proto.timeMax);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.pageToken !== 'undefined') {
      toReturn['pageToken'] = this.pageToken;
    }
    if (typeof this.syncToken !== 'undefined') {
      toReturn['syncToken'] = this.syncToken;
    }
    if (typeof this.timeMin !== 'undefined' && this.timeMin !== null) {
      toReturn['timeMin'] = 'toApiJson' in this.timeMin ? this.timeMin.toApiJson() : this.timeMin;
    }
    if (typeof this.timeMax !== 'undefined' && this.timeMax !== null) {
      toReturn['timeMax'] = 'toApiJson' in this.timeMax ? this.timeMax.toApiJson() : this.timeMax;
    }
    if (typeof this.singleEvents !== 'undefined') {
      toReturn['singleEvents'] = this.singleEvents;
    }
    return toReturn;
  }
}
class GoogleMeetListMeetingsResponse {
  static fromProto(proto) {
    let m = new GoogleMeetListMeetingsResponse();
    m = Object.assign(m, proto);
    if (proto.meetings) {
      m.meetings = proto.meetings.map(GoogleMeetMeeting.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.meetings !== 'undefined' && this.meetings !== null) {
      toReturn['meetings'] = 'toApiJson' in this.meetings ? this.meetings.toApiJson() : this.meetings;
    }
    if (typeof this.nextPageToken !== 'undefined') {
      toReturn['nextPageToken'] = this.nextPageToken;
    }
    if (typeof this.nextSyncToken !== 'undefined') {
      toReturn['nextSyncToken'] = this.nextSyncToken;
    }
    return toReturn;
  }
}
class GoogleMeetMeeting {
  static fromProto(proto) {
    let m = new GoogleMeetMeeting();
    m = Object.assign(m, proto);
    if (proto.attendees) {
      m.attendees = proto.attendees.map(GoogleMeetMeetingAttendee.fromProto);
    }
    if (proto.conferenceData) {
      m.conferenceData = GoogleMeetConferenceData.fromProto(proto.conferenceData);
    }
    if (proto.end) {
      m.end = GoogleMeetMeetingDateTime.fromProto(proto.end);
    }
    if (proto.originalStartTime) {
      m.originalStartTime = GoogleMeetMeetingDateTime.fromProto(proto.originalStartTime);
    }
    if (proto.reminders) {
      m.reminders = GoogleMeetMeetingReminders.fromProto(proto.reminders);
    }
    if (proto.sequence) {
      m.sequence = parseInt(proto.sequence, 10);
    }
    if (proto.start) {
      m.start = GoogleMeetMeetingDateTime.fromProto(proto.start);
    }
    if (proto.creator) {
      m.creator = GoogleMeetMeetingCreator.fromProto(proto.creator);
    }
    if (proto.organizer) {
      m.organizer = GoogleMeetMeetingOrganizer.fromProto(proto.organizer);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.anyoneCanAddSelf !== 'undefined') {
      toReturn['anyoneCanAddSelf'] = this.anyoneCanAddSelf;
    }
    if (typeof this.attendees !== 'undefined' && this.attendees !== null) {
      toReturn['attendees'] = 'toApiJson' in this.attendees ? this.attendees.toApiJson() : this.attendees;
    }
    if (typeof this.attendeesOmitted !== 'undefined') {
      toReturn['attendeesOmitted'] = this.attendeesOmitted;
    }
    if (typeof this.colorId !== 'undefined') {
      toReturn['colorId'] = this.colorId;
    }
    if (typeof this.conferenceData !== 'undefined' && this.conferenceData !== null) {
      toReturn['conferenceData'] = 'toApiJson' in this.conferenceData ? this.conferenceData.toApiJson() : this.conferenceData;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.end !== 'undefined' && this.end !== null) {
      toReturn['end'] = 'toApiJson' in this.end ? this.end.toApiJson() : this.end;
    }
    if (typeof this.endTimeUnspecified !== 'undefined') {
      toReturn['endTimeUnspecified'] = this.endTimeUnspecified;
    }
    if (typeof this.etag !== 'undefined') {
      toReturn['etag'] = this.etag;
    }
    if (typeof this.icalUid !== 'undefined') {
      toReturn['icalUid'] = this.icalUid;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.kind !== 'undefined') {
      toReturn['kind'] = this.kind;
    }
    if (typeof this.location !== 'undefined') {
      toReturn['location'] = this.location;
    }
    if (typeof this.locked !== 'undefined') {
      toReturn['locked'] = this.locked;
    }
    if (typeof this.originalStartTime !== 'undefined' && this.originalStartTime !== null) {
      toReturn['originalStartTime'] = 'toApiJson' in this.originalStartTime ? this.originalStartTime.toApiJson() : this.originalStartTime;
    }
    if (typeof this.recurrence !== 'undefined') {
      toReturn['recurrence'] = this.recurrence;
    }
    if (typeof this.recurringMeetingId !== 'undefined') {
      toReturn['recurringMeetingId'] = this.recurringMeetingId;
    }
    if (typeof this.reminders !== 'undefined' && this.reminders !== null) {
      toReturn['reminders'] = 'toApiJson' in this.reminders ? this.reminders.toApiJson() : this.reminders;
    }
    if (typeof this.sequence !== 'undefined') {
      toReturn['sequence'] = this.sequence;
    }
    if (typeof this.start !== 'undefined' && this.start !== null) {
      toReturn['start'] = 'toApiJson' in this.start ? this.start.toApiJson() : this.start;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.summary !== 'undefined') {
      toReturn['summary'] = this.summary;
    }
    if (typeof this.transparency !== 'undefined') {
      toReturn['transparency'] = this.transparency;
    }
    if (typeof this.visibility !== 'undefined') {
      toReturn['visibility'] = this.visibility;
    }
    if (typeof this.hangoutLink !== 'undefined') {
      toReturn['hangoutLink'] = this.hangoutLink;
    }
    if (typeof this.htmlLink !== 'undefined') {
      toReturn['htmlLink'] = this.htmlLink;
    }
    if (typeof this.created !== 'undefined') {
      toReturn['created'] = this.created;
    }
    if (typeof this.creator !== 'undefined' && this.creator !== null) {
      toReturn['creator'] = 'toApiJson' in this.creator ? this.creator.toApiJson() : this.creator;
    }
    if (typeof this.updated !== 'undefined') {
      toReturn['updated'] = this.updated;
    }
    if (typeof this.organizer !== 'undefined' && this.organizer !== null) {
      toReturn['organizer'] = 'toApiJson' in this.organizer ? this.organizer.toApiJson() : this.organizer;
    }
    return toReturn;
  }
}
class GoogleMeetMeetingAttendee {
  static fromProto(proto) {
    let m = new GoogleMeetMeetingAttendee();
    m = Object.assign(m, proto);
    if (proto.additionalGuests) {
      m.additionalGuests = parseInt(proto.additionalGuests, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.additionalGuests !== 'undefined') {
      toReturn['additionalGuests'] = this.additionalGuests;
    }
    if (typeof this.comment !== 'undefined') {
      toReturn['comment'] = this.comment;
    }
    if (typeof this.displayName !== 'undefined') {
      toReturn['displayName'] = this.displayName;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.optional !== 'undefined') {
      toReturn['optional'] = this.optional;
    }
    if (typeof this.organizer !== 'undefined') {
      toReturn['organizer'] = this.organizer;
    }
    if (typeof this.resource !== 'undefined') {
      toReturn['resource'] = this.resource;
    }
    if (typeof this.responseStatus !== 'undefined') {
      toReturn['responseStatus'] = this.responseStatus;
    }
    if (typeof this.self !== 'undefined') {
      toReturn['self'] = this.self;
    }
    return toReturn;
  }
}
class GoogleMeetMeetingCreator {
  static fromProto(proto) {
    let m = new GoogleMeetMeetingCreator();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.displayName !== 'undefined') {
      toReturn['displayName'] = this.displayName;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.self !== 'undefined') {
      toReturn['self'] = this.self;
    }
    return toReturn;
  }
}
class GoogleMeetMeetingDateTime {
  static fromProto(proto) {
    let m = new GoogleMeetMeetingDateTime();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.date !== 'undefined') {
      toReturn['date'] = this.date;
    }
    if (typeof this.dateTime !== 'undefined') {
      toReturn['dateTime'] = this.dateTime;
    }
    if (typeof this.timeZone !== 'undefined') {
      toReturn['timeZone'] = this.timeZone;
    }
    return toReturn;
  }
}
class GoogleMeetMeetingOrganizer {
  static fromProto(proto) {
    let m = new GoogleMeetMeetingOrganizer();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.displayName !== 'undefined') {
      toReturn['displayName'] = this.displayName;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.self !== 'undefined') {
      toReturn['self'] = this.self;
    }
    return toReturn;
  }
}
class GoogleMeetMeetingReminder {
  static fromProto(proto) {
    let m = new GoogleMeetMeetingReminder();
    m = Object.assign(m, proto);
    if (proto.minutes) {
      m.minutes = parseInt(proto.minutes, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.method !== 'undefined') {
      toReturn['method'] = this.method;
    }
    if (typeof this.minutes !== 'undefined') {
      toReturn['minutes'] = this.minutes;
    }
    return toReturn;
  }
}
class GoogleMeetMeetingReminders {
  static fromProto(proto) {
    let m = new GoogleMeetMeetingReminders();
    m = Object.assign(m, proto);
    if (proto.overrides) {
      m.overrides = proto.overrides.map(GoogleMeetMeetingReminder.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.overrides !== 'undefined' && this.overrides !== null) {
      toReturn['overrides'] = 'toApiJson' in this.overrides ? this.overrides.toApiJson() : this.overrides;
    }
    if (typeof this.useDefault !== 'undefined') {
      toReturn['useDefault'] = this.useDefault;
    }
    return toReturn;
  }
}
function enumStringToValue$8(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Answer {
  static fromProto(proto) {
    let m = new Answer();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue$8(FormFieldType, proto.type);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.answer !== 'undefined') {
      toReturn['answer'] = this.answer;
    }
    return toReturn;
  }
}
class Answers {
  static fromProto(proto) {
    let m = new Answers();
    m = Object.assign(m, proto);
    if (proto.formAnswers) {
      m.formAnswers = proto.formAnswers.map(Answer.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.formAnswers !== 'undefined' && this.formAnswers !== null) {
      toReturn['formAnswers'] = 'toApiJson' in this.formAnswers ? this.formAnswers.toApiJson() : this.formAnswers;
    }
    return toReturn;
  }
}
class CalendarApplicationContextEntry {
  static fromProto(proto) {
    let m = new CalendarApplicationContextEntry();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class Attachment {
  static fromProto(proto) {
    let m = new Attachment();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fileTitle !== 'undefined') {
      toReturn['fileTitle'] = this.fileTitle;
    }
    if (typeof this.fileUrl !== 'undefined') {
      toReturn['fileUrl'] = this.fileUrl;
    }
    if (typeof this.fileType !== 'undefined') {
      toReturn['fileType'] = this.fileType;
    }
    return toReturn;
  }
}
class Attendee {
  static fromProto(proto) {
    let m = new Attendee();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    if (typeof this.timeZone !== 'undefined') {
      toReturn['timeZone'] = this.timeZone;
    }
    if (typeof this.isPrimary !== 'undefined') {
      toReturn['isPrimary'] = this.isPrimary;
    }
    return toReturn;
  }
}
class Calendar {
  static fromProto(proto) {
    let m = new Calendar();
    m = Object.assign(m, proto);
    if (proto.applicationContext) {
      m.applicationContext = Object.keys(proto.applicationContext).reduce((obj, k) => {
        obj[k] = proto.applicationContext[k];
        return obj;
      }, {});
    }
    if (proto.calendarType) {
      m.calendarType = enumStringToValue$8(CalendarType, proto.calendarType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.displayName !== 'undefined') {
      toReturn['displayName'] = this.displayName;
    }
    if (typeof this.displayProfileUrl !== 'undefined') {
      toReturn['displayProfileUrl'] = this.displayProfileUrl;
    }
    if (typeof this.displayLogoUrl !== 'undefined') {
      toReturn['displayLogoUrl'] = this.displayLogoUrl;
    }
    if (typeof this.bookingUrl !== 'undefined') {
      toReturn['bookingUrl'] = this.bookingUrl;
    }
    if (typeof this.slug !== 'undefined') {
      toReturn['slug'] = this.slug;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.creatorUserId !== 'undefined') {
      toReturn['creatorUserId'] = this.creatorUserId;
    }
    if (typeof this.hostUserIds !== 'undefined') {
      toReturn['hostUserIds'] = this.hostUserIds;
    }
    if (typeof this.applicationContext !== 'undefined' && this.applicationContext !== null) {
      toReturn['applicationContext'] = 'toApiJson' in this.applicationContext ? this.applicationContext.toApiJson() : this.applicationContext;
    }
    if (typeof this.calendarType !== 'undefined') {
      toReturn['calendarType'] = this.calendarType;
    }
    if (typeof this.encodedApplicationContext !== 'undefined') {
      toReturn['encodedApplicationContext'] = this.encodedApplicationContext;
    }
    return toReturn;
  }
}
class Contact {
  static fromProto(proto) {
    let m = new Contact();
    m = Object.assign(m, proto);
    if (proto.timeZone) {
      m.timeZone = TimeZone.fromProto(proto.timeZone);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.timeZone !== 'undefined' && this.timeZone !== null) {
      toReturn['timeZone'] = 'toApiJson' in this.timeZone ? this.timeZone.toApiJson() : this.timeZone;
    }
    if (typeof this.isPrimary !== 'undefined') {
      toReturn['isPrimary'] = this.isPrimary;
    }
    return toReturn;
  }
}
class EmailsToDelete {
  static fromProto(proto) {
    let m = new EmailsToDelete();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    return toReturn;
  }
}
class Host {
  static fromProto(proto) {
    let m = new Host();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.displayName !== 'undefined') {
      toReturn['displayName'] = this.displayName;
    }
    if (typeof this.displayProfileUrl !== 'undefined') {
      toReturn['displayProfileUrl'] = this.displayProfileUrl;
    }
    if (typeof this.displayLogoUrl !== 'undefined') {
      toReturn['displayLogoUrl'] = this.displayLogoUrl;
    }
    return toReturn;
  }
}
class HostUser {
  static fromProto(proto) {
    let m = new HostUser();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.displayName !== 'undefined') {
      toReturn['displayName'] = this.displayName;
    }
    if (typeof this.isConfigured !== 'undefined') {
      toReturn['isConfigured'] = this.isConfigured;
    }
    if (typeof this.isConnected !== 'undefined') {
      toReturn['isConnected'] = this.isConnected;
    }
    return toReturn;
  }
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class Preferences {
  static fromProto(proto) {
    let m = new Preferences();
    m = Object.assign(m, proto);
    if (proto.timezone) {
      m.timezone = TimeZone.fromProto(proto.timezone);
    }
    if (proto.meetingIntegration) {
      m.meetingIntegration = enumStringToValue$8(MeetingSource, proto.meetingIntegration);
    }
    if (proto.availabilityIncrement) {
      m.availabilityIncrement = parseInt(proto.availabilityIncrement, 10);
    }
    if (proto.bufferDurationAfterMeeting) {
      m.bufferDurationAfterMeeting = parseInt(proto.bufferDurationAfterMeeting, 10);
    }
    if (proto.noticeTime) {
      m.noticeTime = parseInt(proto.noticeTime, 10);
    }
    if (proto.bufferDurationBeforeMeeting) {
      m.bufferDurationBeforeMeeting = parseInt(proto.bufferDurationBeforeMeeting, 10);
    }
    if (proto.calendarIntegration) {
      m.calendarIntegration = enumStringToValue$8(CalendarSource, proto.calendarIntegration);
    }
    if (proto.onBoardingState) {
      m.onBoardingState = enumStringToValue$8(OnBoardingState, proto.onBoardingState);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.timezone !== 'undefined' && this.timezone !== null) {
      toReturn['timezone'] = 'toApiJson' in this.timezone ? this.timezone.toApiJson() : this.timezone;
    }
    if (typeof this.meetingIntegration !== 'undefined') {
      toReturn['meetingIntegration'] = this.meetingIntegration;
    }
    if (typeof this.availabilityIncrement !== 'undefined') {
      toReturn['availabilityIncrement'] = this.availabilityIncrement;
    }
    if (typeof this.bufferDurationAfterMeeting !== 'undefined') {
      toReturn['bufferDurationAfterMeeting'] = this.bufferDurationAfterMeeting;
    }
    if (typeof this.noticeTime !== 'undefined') {
      toReturn['noticeTime'] = this.noticeTime;
    }
    if (typeof this.calendarSlug !== 'undefined') {
      toReturn['calendarSlug'] = this.calendarSlug;
    }
    if (typeof this.bufferDurationBeforeMeeting !== 'undefined') {
      toReturn['bufferDurationBeforeMeeting'] = this.bufferDurationBeforeMeeting;
    }
    if (typeof this.calendarIntegration !== 'undefined') {
      toReturn['calendarIntegration'] = this.calendarIntegration;
    }
    if (typeof this.onBoardingState !== 'undefined') {
      toReturn['onBoardingState'] = this.onBoardingState;
    }
    return toReturn;
  }
}
class TimeRange {
  static fromProto(proto) {
    let m = new TimeRange();
    m = Object.assign(m, proto);
    if (proto.from) {
      m.from = TimeOfDay.fromProto(proto.from);
    }
    if (proto.to) {
      m.to = TimeOfDay.fromProto(proto.to);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.from !== 'undefined' && this.from !== null) {
      toReturn['from'] = 'toApiJson' in this.from ? this.from.toApiJson() : this.from;
    }
    if (typeof this.to !== 'undefined' && this.to !== null) {
      toReturn['to'] = 'toApiJson' in this.to ? this.to.toApiJson() : this.to;
    }
    return toReturn;
  }
}
function enumStringToValue$7(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class DateRange {
  static fromProto(proto) {
    let m = new DateRange();
    m = Object.assign(m, proto);
    if (proto.start) {
      m.start = new Date(proto.start);
    }
    if (proto.end) {
      m.end = new Date(proto.end);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.start !== 'undefined' && this.start !== null) {
      toReturn['start'] = 'toApiJson' in this.start ? this.start.toApiJson() : this.start;
    }
    if (typeof this.end !== 'undefined' && this.end !== null) {
      toReturn['end'] = 'toApiJson' in this.end ? this.end.toApiJson() : this.end;
    }
    return toReturn;
  }
}
function enumStringToValue$6(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class EventTypeDateRange {
  static fromProto(proto) {
    let m = new EventTypeDateRange();
    m = Object.assign(m, proto);
    if (proto.dateRangeType) {
      m.dateRangeType = enumStringToValue$6(DateRangeType, proto.dateRangeType);
    }
    if (proto.customDateRange) {
      m.customDateRange = DateRange.fromProto(proto.customDateRange);
    }
    if (proto.relativeDateRange) {
      m.relativeDateRange = RelativeDateRange.fromProto(proto.relativeDateRange);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.dateRangeType !== 'undefined') {
      toReturn['dateRangeType'] = this.dateRangeType;
    }
    if (typeof this.customDateRange !== 'undefined' && this.customDateRange !== null) {
      toReturn['customDateRange'] = 'toApiJson' in this.customDateRange ? this.customDateRange.toApiJson() : this.customDateRange;
    }
    if (typeof this.relativeDateRange !== 'undefined' && this.relativeDateRange !== null) {
      toReturn['relativeDateRange'] = 'toApiJson' in this.relativeDateRange ? this.relativeDateRange.toApiJson() : this.relativeDateRange;
    }
    return toReturn;
  }
}
class Field {
  static fromProto(proto) {
    let m = new Field();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue$6(FormFieldType, proto.type);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.required !== 'undefined') {
      toReturn['required'] = this.required;
    }
    return toReturn;
  }
}
class Form {
  static fromProto(proto) {
    let m = new Form();
    m = Object.assign(m, proto);
    if (proto.fields) {
      m.fields = proto.fields.map(Field.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fields !== 'undefined' && this.fields !== null) {
      toReturn['fields'] = 'toApiJson' in this.fields ? this.fields.toApiJson() : this.fields;
    }
    return toReturn;
  }
}
class MeetingType {
  static fromProto(proto) {
    let m = new MeetingType();
    m = Object.assign(m, proto);
    if (proto.form) {
      m.form = Form.fromProto(proto.form);
    }
    if (proto.availabilityIncrement) {
      m.availabilityIncrement = parseInt(proto.availabilityIncrement, 10);
    }
    if (proto.bufferDurationAfterMeeting) {
      m.bufferDurationAfterMeeting = parseInt(proto.bufferDurationAfterMeeting, 10);
    }
    if (proto.noticeTime) {
      m.noticeTime = parseInt(proto.noticeTime, 10);
    }
    if (proto.locationType) {
      m.locationType = enumStringToValue$6(MeetingLocationType, proto.locationType);
    }
    if (proto.hostUsers) {
      m.hostUsers = proto.hostUsers.map(HostUser.fromProto);
    }
    if (proto.bufferDurationBeforeMeeting) {
      m.bufferDurationBeforeMeeting = parseInt(proto.bufferDurationBeforeMeeting, 10);
    }
    if (proto.dateRange) {
      m.dateRange = EventTypeDateRange.fromProto(proto.dateRange);
    }
    if (proto.meetingType) {
      m.meetingType = enumStringToValue$6(TeamEventMeetingType, proto.meetingType);
    }
    if (proto.attendeeCount) {
      m.attendeeCount = parseInt(proto.attendeeCount, 10);
    }
    if (proto.registrationCutoff) {
      m.registrationCutoff = RegistrationCutOff.fromProto(proto.registrationCutoff);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.duration !== 'undefined') {
      toReturn['duration'] = this.duration;
    }
    if (typeof this.calendarId !== 'undefined') {
      toReturn['calendarId'] = this.calendarId;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.hexColor !== 'undefined') {
      toReturn['hexColor'] = this.hexColor;
    }
    if (typeof this.meetingTypeSlug !== 'undefined') {
      toReturn['meetingTypeSlug'] = this.meetingTypeSlug;
    }
    if (typeof this.isPrivate !== 'undefined') {
      toReturn['isPrivate'] = this.isPrivate;
    }
    if (typeof this.form !== 'undefined' && this.form !== null) {
      toReturn['form'] = 'toApiJson' in this.form ? this.form.toApiJson() : this.form;
    }
    if (typeof this.isReserveWithGoogleService !== 'undefined') {
      toReturn['isReserveWithGoogleService'] = this.isReserveWithGoogleService;
    }
    if (typeof this.hostUserIds !== 'undefined') {
      toReturn['hostUserIds'] = this.hostUserIds;
    }
    if (typeof this.bookingUrl !== 'undefined') {
      toReturn['bookingUrl'] = this.bookingUrl;
    }
    if (typeof this.availabilityIncrement !== 'undefined') {
      toReturn['availabilityIncrement'] = this.availabilityIncrement;
    }
    if (typeof this.bufferDurationAfterMeeting !== 'undefined') {
      toReturn['bufferDurationAfterMeeting'] = this.bufferDurationAfterMeeting;
    }
    if (typeof this.noticeTime !== 'undefined') {
      toReturn['noticeTime'] = this.noticeTime;
    }
    if (typeof this.location !== 'undefined') {
      toReturn['location'] = this.location;
    }
    if (typeof this.locationType !== 'undefined') {
      toReturn['locationType'] = this.locationType;
    }
    if (typeof this.locationGuidelines !== 'undefined') {
      toReturn['locationGuidelines'] = this.locationGuidelines;
    }
    if (typeof this.emailSubject !== 'undefined') {
      toReturn['emailSubject'] = this.emailSubject;
    }
    if (typeof this.emailDescription !== 'undefined') {
      toReturn['emailDescription'] = this.emailDescription;
    }
    if (typeof this.isPinned !== 'undefined') {
      toReturn['isPinned'] = this.isPinned;
    }
    if (typeof this.calendarType !== 'undefined') {
      toReturn['calendarType'] = this.calendarType;
    }
    if (typeof this.hostUsers !== 'undefined' && this.hostUsers !== null) {
      toReturn['hostUsers'] = 'toApiJson' in this.hostUsers ? this.hostUsers.toApiJson() : this.hostUsers;
    }
    if (typeof this.teamName !== 'undefined') {
      toReturn['teamName'] = this.teamName;
    }
    if (typeof this.isVideoLinkDisabled !== 'undefined') {
      toReturn['isVideoLinkDisabled'] = this.isVideoLinkDisabled;
    }
    if (typeof this.bufferDurationBeforeMeeting !== 'undefined') {
      toReturn['bufferDurationBeforeMeeting'] = this.bufferDurationBeforeMeeting;
    }
    if (typeof this.dateRange !== 'undefined' && this.dateRange !== null) {
      toReturn['dateRange'] = 'toApiJson' in this.dateRange ? this.dateRange.toApiJson() : this.dateRange;
    }
    if (typeof this.meetingType !== 'undefined') {
      toReturn['meetingType'] = this.meetingType;
    }
    if (typeof this.attendeeCount !== 'undefined') {
      toReturn['attendeeCount'] = this.attendeeCount;
    }
    if (typeof this.sessionTitle !== 'undefined') {
      toReturn['sessionTitle'] = this.sessionTitle;
    }
    if (typeof this.registrationCutoff !== 'undefined' && this.registrationCutoff !== null) {
      toReturn['registrationCutoff'] = 'toApiJson' in this.registrationCutoff ? this.registrationCutoff.toApiJson() : this.registrationCutoff;
    }
    return toReturn;
  }
}
class RegistrationCutOff {
  static fromProto(proto) {
    let m = new RegistrationCutOff();
    m = Object.assign(m, proto);
    if (proto.unit) {
      m.unit = enumStringToValue$6(RegistrationCutOffUnit, proto.unit);
    }
    if (proto.value) {
      m.value = parseInt(proto.value, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.unit !== 'undefined') {
      toReturn['unit'] = this.unit;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class RelativeDateRange {
  static fromProto(proto) {
    let m = new RelativeDateRange();
    m = Object.assign(m, proto);
    if (proto.unit) {
      m.unit = enumStringToValue$6(RelativeTimeUnit, proto.unit);
    }
    if (proto.value) {
      m.value = parseInt(proto.value, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.unit !== 'undefined') {
      toReturn['unit'] = this.unit;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
function enumStringToValue$5(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class EventGroupAndServiceAssociations {
  static fromProto(proto) {
    let m = new EventGroupAndServiceAssociations();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.eventType !== 'undefined') {
      toReturn['eventType'] = this.eventType;
    }
    if (typeof this.identifier !== 'undefined') {
      toReturn['identifier'] = this.identifier;
    }
    if (typeof this.isEditable !== 'undefined') {
      toReturn['isEditable'] = this.isEditable;
    }
    if (typeof this.creatorUserName !== 'undefined') {
      toReturn['creatorUserName'] = this.creatorUserName;
    }
    if (typeof this.calendarId !== 'undefined') {
      toReturn['calendarId'] = this.calendarId;
    }
    if (typeof this.hexColor !== 'undefined') {
      toReturn['hexColor'] = this.hexColor;
    }
    if (typeof this.duration !== 'undefined') {
      toReturn['duration'] = this.duration;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.bookingUrl !== 'undefined') {
      toReturn['bookingUrl'] = this.bookingUrl;
    }
    return toReturn;
  }
}
class Group {
  static fromProto(proto) {
    let m = new Group();
    m = Object.assign(m, proto);
    if (proto.associations) {
      m.associations = proto.associations.map(EventGroupAndServiceAssociations.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.slug !== 'undefined') {
      toReturn['slug'] = this.slug;
    }
    if (typeof this.isPinned !== 'undefined') {
      toReturn['isPinned'] = this.isPinned;
    }
    if (typeof this.associations !== 'undefined' && this.associations !== null) {
      toReturn['associations'] = 'toApiJson' in this.associations ? this.associations.toApiJson() : this.associations;
    }
    if (typeof this.hexColor !== 'undefined') {
      toReturn['hexColor'] = this.hexColor;
    }
    if (typeof this.bookingUrl !== 'undefined') {
      toReturn['bookingUrl'] = this.bookingUrl;
    }
    return toReturn;
  }
}
class Service {
  static fromProto(proto) {
    let m = new Service();
    m = Object.assign(m, proto);
    if (proto.associations) {
      m.associations = proto.associations.map(EventGroupAndServiceAssociations.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.slug !== 'undefined') {
      toReturn['slug'] = this.slug;
    }
    if (typeof this.isPinned !== 'undefined') {
      toReturn['isPinned'] = this.isPinned;
    }
    if (typeof this.associations !== 'undefined' && this.associations !== null) {
      toReturn['associations'] = 'toApiJson' in this.associations ? this.associations.toApiJson() : this.associations;
    }
    if (typeof this.hexColor !== 'undefined') {
      toReturn['hexColor'] = this.hexColor;
    }
    if (typeof this.bookingUrl !== 'undefined') {
      toReturn['bookingUrl'] = this.bookingUrl;
    }
    return toReturn;
  }
}
function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class BookMeetingRequest {
  static fromProto(proto) {
    let m = new BookMeetingRequest();
    m = Object.assign(m, proto);
    if (proto.timeSlot) {
      m.timeSlot = DateRange.fromProto(proto.timeSlot);
    }
    if (proto.attendees) {
      m.attendees = proto.attendees.map(Contact.fromProto);
    }
    if (proto.start) {
      m.start = new Date(proto.start);
    }
    if (proto.metadata) {
      m.metadata = Object.keys(proto.metadata).reduce((obj, k) => {
        obj[k] = proto.metadata[k];
        return obj;
      }, {});
    }
    if (proto.formAnswers) {
      m.formAnswers = Answers.fromProto(proto.formAnswers);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hostId !== 'undefined') {
      toReturn['hostId'] = this.hostId;
    }
    if (typeof this.meetingTypeId !== 'undefined') {
      toReturn['meetingTypeId'] = this.meetingTypeId;
    }
    if (typeof this.timeSlot !== 'undefined' && this.timeSlot !== null) {
      toReturn['timeSlot'] = 'toApiJson' in this.timeSlot ? this.timeSlot.toApiJson() : this.timeSlot;
    }
    if (typeof this.attendees !== 'undefined' && this.attendees !== null) {
      toReturn['attendees'] = 'toApiJson' in this.attendees ? this.attendees.toApiJson() : this.attendees;
    }
    if (typeof this.start !== 'undefined' && this.start !== null) {
      toReturn['start'] = 'toApiJson' in this.start ? this.start.toApiJson() : this.start;
    }
    if (typeof this.comment !== 'undefined') {
      toReturn['comment'] = this.comment;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    if (typeof this.formAnswers !== 'undefined' && this.formAnswers !== null) {
      toReturn['formAnswers'] = 'toApiJson' in this.formAnswers ? this.formAnswers.toApiJson() : this.formAnswers;
    }
    if (typeof this.recaptchaToken !== 'undefined') {
      toReturn['recaptchaToken'] = this.recaptchaToken;
    }
    if (typeof this.location !== 'undefined') {
      toReturn['location'] = this.location;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
class BookMeetingResponse {
  static fromProto(proto) {
    let m = new BookMeetingResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.meetingId !== 'undefined') {
      toReturn['meetingId'] = this.meetingId;
    }
    if (typeof this.hostId !== 'undefined') {
      toReturn['hostId'] = this.hostId;
    }
    return toReturn;
  }
}
class GetCalendarRequest {
  static fromProto(proto) {
    let m = new GetCalendarRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.calendarId !== 'undefined') {
      toReturn['calendarId'] = this.calendarId;
    }
    return toReturn;
  }
}
class GetCalendarResponse {
  static fromProto(proto) {
    let m = new GetCalendarResponse();
    m = Object.assign(m, proto);
    if (proto.calendar) {
      m.calendar = Calendar.fromProto(proto.calendar);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.calendar !== 'undefined' && this.calendar !== null) {
      toReturn['calendar'] = 'toApiJson' in this.calendar ? this.calendar.toApiJson() : this.calendar;
    }
    return toReturn;
  }
}
class GetGroupRequest {
  static fromProto(proto) {
    let m = new GetGroupRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.groupId !== 'undefined') {
      toReturn['groupId'] = this.groupId;
    }
    if (typeof this.slug !== 'undefined') {
      toReturn['slug'] = this.slug;
    }
    if (typeof this.hostId !== 'undefined') {
      toReturn['hostId'] = this.hostId;
    }
    return toReturn;
  }
}
class GetGroupResponse {
  static fromProto(proto) {
    let m = new GetGroupResponse();
    m = Object.assign(m, proto);
    if (proto.group) {
      m.group = Group.fromProto(proto.group);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.group !== 'undefined' && this.group !== null) {
      toReturn['group'] = 'toApiJson' in this.group ? this.group.toApiJson() : this.group;
    }
    if (typeof this.businessDisplayLogoUrl !== 'undefined') {
      toReturn['businessDisplayLogoUrl'] = this.businessDisplayLogoUrl;
    }
    return toReturn;
  }
}
class GetHostRequest {
  static fromProto(proto) {
    let m = new GetHostRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hostId !== 'undefined') {
      toReturn['hostId'] = this.hostId;
    }
    return toReturn;
  }
}
class GetHostResponse {
  static fromProto(proto) {
    let m = new GetHostResponse();
    m = Object.assign(m, proto);
    if (proto.host) {
      m.host = Host.fromProto(proto.host);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.host !== 'undefined' && this.host !== null) {
      toReturn['host'] = 'toApiJson' in this.host ? this.host.toApiJson() : this.host;
    }
    return toReturn;
  }
}
class GetMeetingTypeRequest {
  static fromProto(proto) {
    let m = new GetMeetingTypeRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.calendarSlug !== 'undefined') {
      toReturn['calendarSlug'] = this.calendarSlug;
    }
    if (typeof this.meetingTypeSlug !== 'undefined') {
      toReturn['meetingTypeSlug'] = this.meetingTypeSlug;
    }
    return toReturn;
  }
}
class GetMeetingTypeResponse {
  static fromProto(proto) {
    let m = new GetMeetingTypeResponse();
    m = Object.assign(m, proto);
    if (proto.meetingType) {
      m.meetingType = MeetingType.fromProto(proto.meetingType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.meetingType !== 'undefined' && this.meetingType !== null) {
      toReturn['meetingType'] = 'toApiJson' in this.meetingType ? this.meetingType.toApiJson() : this.meetingType;
    }
    return toReturn;
  }
}
class GetServiceRequest {
  static fromProto(proto) {
    let m = new GetServiceRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.serviceId !== 'undefined') {
      toReturn['serviceId'] = this.serviceId;
    }
    if (typeof this.slug !== 'undefined') {
      toReturn['slug'] = this.slug;
    }
    if (typeof this.hostId !== 'undefined') {
      toReturn['hostId'] = this.hostId;
    }
    return toReturn;
  }
}
class GetServiceResponse {
  static fromProto(proto) {
    let m = new GetServiceResponse();
    m = Object.assign(m, proto);
    if (proto.service) {
      m.service = Service.fromProto(proto.service);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.service !== 'undefined' && this.service !== null) {
      toReturn['service'] = 'toApiJson' in this.service ? this.service.toApiJson() : this.service;
    }
    if (typeof this.businessDisplayLogoUrl !== 'undefined') {
      toReturn['businessDisplayLogoUrl'] = this.businessDisplayLogoUrl;
    }
    return toReturn;
  }
}
class GuestCancelMeetingRequest {
  static fromProto(proto) {
    let m = new GuestCancelMeetingRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.meetingId !== 'undefined') {
      toReturn['meetingId'] = this.meetingId;
    }
    if (typeof this.authToken !== 'undefined') {
      toReturn['authToken'] = this.authToken;
    }
    if (typeof this.cancellationReason !== 'undefined') {
      toReturn['cancellationReason'] = this.cancellationReason;
    }
    return toReturn;
  }
}
class GuestGetBookedMeetingRequest {
  static fromProto(proto) {
    let m = new GuestGetBookedMeetingRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.meetingId !== 'undefined') {
      toReturn['meetingId'] = this.meetingId;
    }
    if (typeof this.authToken !== 'undefined') {
      toReturn['authToken'] = this.authToken;
    }
    return toReturn;
  }
}
class GuestGetBookedMeetingResponse {
  static fromProto(proto) {
    let m = new GuestGetBookedMeetingResponse();
    m = Object.assign(m, proto);
    if (proto.startTime) {
      m.startTime = new Date(proto.startTime);
    }
    if (proto.endTime) {
      m.endTime = new Date(proto.endTime);
    }
    if (proto.timeZone) {
      m.timeZone = TimeZone.fromProto(proto.timeZone);
    }
    if (proto.locationType) {
      m.locationType = enumStringToValue$4(MeetingLocationType, proto.locationType);
    }
    if (proto.meetingType) {
      m.meetingType = enumStringToValue$4(TeamEventMeetingType, proto.meetingType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.startTime !== 'undefined' && this.startTime !== null) {
      toReturn['startTime'] = 'toApiJson' in this.startTime ? this.startTime.toApiJson() : this.startTime;
    }
    if (typeof this.endTime !== 'undefined' && this.endTime !== null) {
      toReturn['endTime'] = 'toApiJson' in this.endTime ? this.endTime.toApiJson() : this.endTime;
    }
    if (typeof this.timeZone !== 'undefined' && this.timeZone !== null) {
      toReturn['timeZone'] = 'toApiJson' in this.timeZone ? this.timeZone.toApiJson() : this.timeZone;
    }
    if (typeof this.meetingTypeId !== 'undefined') {
      toReturn['meetingTypeId'] = this.meetingTypeId;
    }
    if (typeof this.location !== 'undefined') {
      toReturn['location'] = this.location;
    }
    if (typeof this.locationType !== 'undefined') {
      toReturn['locationType'] = this.locationType;
    }
    if (typeof this.locationGuideline !== 'undefined') {
      toReturn['locationGuideline'] = this.locationGuideline;
    }
    if (typeof this.meetingType !== 'undefined') {
      toReturn['meetingType'] = this.meetingType;
    }
    if (typeof this.displayName !== 'undefined') {
      toReturn['displayName'] = this.displayName;
    }
    if (typeof this.calendarId !== 'undefined') {
      toReturn['calendarId'] = this.calendarId;
    }
    return toReturn;
  }
}
class GuestIsHostConfiguredRequest {
  static fromProto(proto) {
    let m = new GuestIsHostConfiguredRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hostId !== 'undefined') {
      toReturn['hostId'] = this.hostId;
    }
    return toReturn;
  }
}
class GuestIsHostConfiguredResponse {
  static fromProto(proto) {
    let m = new GuestIsHostConfiguredResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.isConfigured !== 'undefined') {
      toReturn['isConfigured'] = this.isConfigured;
    }
    return toReturn;
  }
}
class GuestRescheduleMeetingRequest {
  static fromProto(proto) {
    let m = new GuestRescheduleMeetingRequest();
    m = Object.assign(m, proto);
    if (proto.start) {
      m.start = new Date(proto.start);
    }
    if (proto.timeZone) {
      m.timeZone = TimeZone.fromProto(proto.timeZone);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.meetingId !== 'undefined') {
      toReturn['meetingId'] = this.meetingId;
    }
    if (typeof this.authToken !== 'undefined') {
      toReturn['authToken'] = this.authToken;
    }
    if (typeof this.start !== 'undefined' && this.start !== null) {
      toReturn['start'] = 'toApiJson' in this.start ? this.start.toApiJson() : this.start;
    }
    if (typeof this.timeZone !== 'undefined' && this.timeZone !== null) {
      toReturn['timeZone'] = 'toApiJson' in this.timeZone ? this.timeZone.toApiJson() : this.timeZone;
    }
    if (typeof this.location !== 'undefined') {
      toReturn['location'] = this.location;
    }
    return toReturn;
  }
}
class IsoDateTimeRange {
  static fromProto(proto) {
    let m = new IsoDateTimeRange();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.start !== 'undefined') {
      toReturn['start'] = this.start;
    }
    if (typeof this.end !== 'undefined') {
      toReturn['end'] = this.end;
    }
    return toReturn;
  }
}
class ListAvailableTimeSlotsRequest {
  static fromProto(proto) {
    let m = new ListAvailableTimeSlotsRequest();
    m = Object.assign(m, proto);
    if (proto.timeSpan) {
      m.timeSpan = DateRange.fromProto(proto.timeSpan);
    }
    if (proto.timeZone) {
      m.timeZone = TimeZone.fromProto(proto.timeZone);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hostId !== 'undefined') {
      toReturn['hostId'] = this.hostId;
    }
    if (typeof this.meetingTypeId !== 'undefined') {
      toReturn['meetingTypeId'] = this.meetingTypeId;
    }
    if (typeof this.timeSpan !== 'undefined' && this.timeSpan !== null) {
      toReturn['timeSpan'] = 'toApiJson' in this.timeSpan ? this.timeSpan.toApiJson() : this.timeSpan;
    }
    if (typeof this.timeZone !== 'undefined' && this.timeZone !== null) {
      toReturn['timeZone'] = 'toApiJson' in this.timeZone ? this.timeZone.toApiJson() : this.timeZone;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.useIsoDates !== 'undefined') {
      toReturn['useIsoDates'] = this.useIsoDates;
    }
    return toReturn;
  }
}
class ListAvailableTimeSlotsResponse {
  static fromProto(proto) {
    let m = new ListAvailableTimeSlotsResponse();
    m = Object.assign(m, proto);
    if (proto.timeSlots) {
      m.timeSlots = proto.timeSlots.map(DateRange.fromProto);
    }
    if (proto.isoTimeSlots) {
      m.isoTimeSlots = proto.isoTimeSlots.map(IsoDateTimeRange.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.timeSlots !== 'undefined' && this.timeSlots !== null) {
      toReturn['timeSlots'] = 'toApiJson' in this.timeSlots ? this.timeSlots.toApiJson() : this.timeSlots;
    }
    if (typeof this.isoTimeSlots !== 'undefined' && this.isoTimeSlots !== null) {
      toReturn['isoTimeSlots'] = 'toApiJson' in this.isoTimeSlots ? this.isoTimeSlots.toApiJson() : this.isoTimeSlots;
    }
    return toReturn;
  }
}
class ListMeetingTypesRequest {
  static fromProto(proto) {
    let m = new ListMeetingTypesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hostId !== 'undefined') {
      toReturn['hostId'] = this.hostId;
    }
    return toReturn;
  }
}
class ListMeetingTypesResponse {
  static fromProto(proto) {
    let m = new ListMeetingTypesResponse();
    m = Object.assign(m, proto);
    if (proto.meetingTypes) {
      m.meetingTypes = proto.meetingTypes.map(MeetingType.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.meetingTypes !== 'undefined' && this.meetingTypes !== null) {
      toReturn['meetingTypes'] = 'toApiJson' in this.meetingTypes ? this.meetingTypes.toApiJson() : this.meetingTypes;
    }
    return toReturn;
  }
}
class BookMeetingRequestMetadataEntry {
  static fromProto(proto) {
    let m = new BookMeetingRequestMetadataEntry();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class RegisterSessionRequest {
  static fromProto(proto) {
    let m = new RegisterSessionRequest();
    m = Object.assign(m, proto);
    if (proto.attendees) {
      m.attendees = proto.attendees.map(Contact.fromProto);
    }
    if (proto.formAnswers) {
      m.formAnswers = Answers.fromProto(proto.formAnswers);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.meetingId !== 'undefined') {
      toReturn['meetingId'] = this.meetingId;
    }
    if (typeof this.attendees !== 'undefined' && this.attendees !== null) {
      toReturn['attendees'] = 'toApiJson' in this.attendees ? this.attendees.toApiJson() : this.attendees;
    }
    if (typeof this.comment !== 'undefined') {
      toReturn['comment'] = this.comment;
    }
    if (typeof this.formAnswers !== 'undefined' && this.formAnswers !== null) {
      toReturn['formAnswers'] = 'toApiJson' in this.formAnswers ? this.formAnswers.toApiJson() : this.formAnswers;
    }
    if (typeof this.recaptchaToken !== 'undefined') {
      toReturn['recaptchaToken'] = this.recaptchaToken;
    }
    return toReturn;
  }
}
class GetSessionMeetingRequest {
  static fromProto(proto) {
    let m = new GetSessionMeetingRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.meetingId !== 'undefined') {
      toReturn['meetingId'] = this.meetingId;
    }
    if (typeof this.slug !== 'undefined') {
      toReturn['slug'] = this.slug;
    }
    return toReturn;
  }
}
class GetSessionMeetingResponse {
  static fromProto(proto) {
    let m = new GetSessionMeetingResponse();
    m = Object.assign(m, proto);
    if (proto.start) {
      m.start = new Date(proto.start);
    }
    if (proto.hostUsers) {
      m.hostUsers = proto.hostUsers.map(HostUser.fromProto);
    }
    if (proto.form) {
      m.form = Form.fromProto(proto.form);
    }
    if (proto.registrationCutOffTime) {
      m.registrationCutOffTime = new Date(proto.registrationCutOffTime);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.location !== 'undefined') {
      toReturn['location'] = this.location;
    }
    if (typeof this.start !== 'undefined' && this.start !== null) {
      toReturn['start'] = 'toApiJson' in this.start ? this.start.toApiJson() : this.start;
    }
    if (typeof this.duration !== 'undefined') {
      toReturn['duration'] = this.duration;
    }
    if (typeof this.businessLogoUrl !== 'undefined') {
      toReturn['businessLogoUrl'] = this.businessLogoUrl;
    }
    if (typeof this.imageUrl !== 'undefined') {
      toReturn['imageUrl'] = this.imageUrl;
    }
    if (typeof this.hostUsers !== 'undefined' && this.hostUsers !== null) {
      toReturn['hostUsers'] = 'toApiJson' in this.hostUsers ? this.hostUsers.toApiJson() : this.hostUsers;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.form !== 'undefined' && this.form !== null) {
      toReturn['form'] = 'toApiJson' in this.form ? this.form.toApiJson() : this.form;
    }
    if (typeof this.attendeeCount !== 'undefined') {
      toReturn['attendeeCount'] = this.attendeeCount;
    }
    if (typeof this.registeredAttendeeCount !== 'undefined') {
      toReturn['registeredAttendeeCount'] = this.registeredAttendeeCount;
    }
    if (typeof this.registrationCutOffTime !== 'undefined' && this.registrationCutOffTime !== null) {
      toReturn['registrationCutOffTime'] = 'toApiJson' in this.registrationCutOffTime ? this.registrationCutOffTime.toApiJson() : this.registrationCutOffTime;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FieldMask {
  static fromProto(proto) {
    let m = new FieldMask();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paths !== 'undefined') {
      toReturn['paths'] = this.paths;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class BuildHostIdRequestApplicationContextPropertiesEntry {
  static fromProto(proto) {
    let m = new BuildHostIdRequestApplicationContextPropertiesEntry();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class EnsurePersonalCalendarExistsRequestApplicationContextPropertiesEntry {
  static fromProto(proto) {
    let m = new EnsurePersonalCalendarExistsRequestApplicationContextPropertiesEntry();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class IsCalendarConfiguredRequestApplicationContextPropertiesEntry {
  static fromProto(proto) {
    let m = new IsCalendarConfiguredRequestApplicationContextPropertiesEntry();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class AvailabilityRule {
  static fromProto(proto) {
    let m = new AvailabilityRule();
    m = Object.assign(m, proto);
    if (proto.day) {
      m.day = enumStringToValue$2(DayOfWeek, proto.day);
    }
    if (proto.timeSlot) {
      m.timeSlot = TimeRange.fromProto(proto.timeSlot);
    }
    if (proto.timeZone) {
      m.timeZone = TimeZone.fromProto(proto.timeZone);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hostId !== 'undefined') {
      toReturn['hostId'] = this.hostId;
    }
    if (typeof this.meetingTypeId !== 'undefined') {
      toReturn['meetingTypeId'] = this.meetingTypeId;
    }
    if (typeof this.day !== 'undefined') {
      toReturn['day'] = this.day;
    }
    if (typeof this.timeSlot !== 'undefined' && this.timeSlot !== null) {
      toReturn['timeSlot'] = 'toApiJson' in this.timeSlot ? this.timeSlot.toApiJson() : this.timeSlot;
    }
    if (typeof this.timeZone !== 'undefined' && this.timeZone !== null) {
      toReturn['timeZone'] = 'toApiJson' in this.timeZone ? this.timeZone.toApiJson() : this.timeZone;
    }
    return toReturn;
  }
}
class AvailabilityRuleList {
  static fromProto(proto) {
    let m = new AvailabilityRuleList();
    m = Object.assign(m, proto);
    if (proto.rules) {
      m.rules = proto.rules.map(AvailabilityRule.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.rules !== 'undefined' && this.rules !== null) {
      toReturn['rules'] = 'toApiJson' in this.rules ? this.rules.toApiJson() : this.rules;
    }
    return toReturn;
  }
}
class BuildHostIdRequest {
  static fromProto(proto) {
    let m = new BuildHostIdRequest();
    m = Object.assign(m, proto);
    if (proto.applicationContextProperties) {
      m.applicationContextProperties = Object.keys(proto.applicationContextProperties).reduce((obj, k) => {
        obj[k] = proto.applicationContextProperties[k];
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.applicationContextProperties !== 'undefined' && this.applicationContextProperties !== null) {
      toReturn['applicationContextProperties'] = 'toApiJson' in this.applicationContextProperties ? this.applicationContextProperties.toApiJson() : this.applicationContextProperties;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
class BuildHostIdResponse {
  static fromProto(proto) {
    let m = new BuildHostIdResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hostId !== 'undefined') {
      toReturn['hostId'] = this.hostId;
    }
    return toReturn;
  }
}
class GetMeetingTypesForCalendarsResponseCalendarMeetingTypesMapEntry {
  static fromProto(proto) {
    let m = new GetMeetingTypesForCalendarsResponseCalendarMeetingTypesMapEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = MeetingTypeList.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class CalendarMigrationResponse {
  static fromProto(proto) {
    let m = new CalendarMigrationResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    return toReturn;
  }
}
class CancelMeetingRequest {
  static fromProto(proto) {
    let m = new CancelMeetingRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.meetingId !== 'undefined') {
      toReturn['meetingId'] = this.meetingId;
    }
    if (typeof this.cancellationReason !== 'undefined') {
      toReturn['cancellationReason'] = this.cancellationReason;
    }
    return toReturn;
  }
}
class CheckGroupOrServiceSlugExistRequest {
  static fromProto(proto) {
    let m = new CheckGroupOrServiceSlugExistRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hostId !== 'undefined') {
      toReturn['hostId'] = this.hostId;
    }
    if (typeof this.slugIdentifier !== 'undefined') {
      toReturn['slugIdentifier'] = this.slugIdentifier;
    }
    if (typeof this.category !== 'undefined') {
      toReturn['category'] = this.category;
    }
    return toReturn;
  }
}
class CheckGroupOrServiceSlugExistResponse {
  static fromProto(proto) {
    let m = new CheckGroupOrServiceSlugExistResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.exists !== 'undefined') {
      toReturn['exists'] = this.exists;
    }
    return toReturn;
  }
}
class CreateAvailabilityRequest {
  static fromProto(proto) {
    let m = new CreateAvailabilityRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class CreateAvailabilityResponse {
  static fromProto(proto) {
    let m = new CreateAvailabilityResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class CreateCalendarRequest {
  static fromProto(proto) {
    let m = new CreateCalendarRequest();
    m = Object.assign(m, proto);
    if (proto.calendar) {
      m.calendar = Calendar.fromProto(proto.calendar);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.calendar !== 'undefined' && this.calendar !== null) {
      toReturn['calendar'] = 'toApiJson' in this.calendar ? this.calendar.toApiJson() : this.calendar;
    }
    return toReturn;
  }
}
class CreateCalendarResponse {
  static fromProto(proto) {
    let m = new CreateCalendarResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.calendarId !== 'undefined') {
      toReturn['calendarId'] = this.calendarId;
    }
    return toReturn;
  }
}
class CreateDefaultMeetingTypesRequest {
  static fromProto(proto) {
    let m = new CreateDefaultMeetingTypesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.calendarId !== 'undefined') {
      toReturn['calendarId'] = this.calendarId;
    }
    if (typeof this.calendarIds !== 'undefined') {
      toReturn['calendarIds'] = this.calendarIds;
    }
    return toReturn;
  }
}
class CreateGroupRequest {
  static fromProto(proto) {
    let m = new CreateGroupRequest();
    m = Object.assign(m, proto);
    if (proto.group) {
      m.group = Group.fromProto(proto.group);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.group !== 'undefined' && this.group !== null) {
      toReturn['group'] = 'toApiJson' in this.group ? this.group.toApiJson() : this.group;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    if (typeof this.hostId !== 'undefined') {
      toReturn['hostId'] = this.hostId;
    }
    return toReturn;
  }
}
class CreateGroupResponse {
  static fromProto(proto) {
    let m = new CreateGroupResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class CreateMeetingTypeRequest {
  static fromProto(proto) {
    let m = new CreateMeetingTypeRequest();
    m = Object.assign(m, proto);
    if (proto.meetingType) {
      m.meetingType = MeetingType.fromProto(proto.meetingType);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.meetingType !== 'undefined' && this.meetingType !== null) {
      toReturn['meetingType'] = 'toApiJson' in this.meetingType ? this.meetingType.toApiJson() : this.meetingType;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    if (typeof this.hostId !== 'undefined') {
      toReturn['hostId'] = this.hostId;
    }
    return toReturn;
  }
}
class CreateMeetingTypeResponse {
  static fromProto(proto) {
    let m = new CreateMeetingTypeResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class CreateServiceRequest {
  static fromProto(proto) {
    let m = new CreateServiceRequest();
    m = Object.assign(m, proto);
    if (proto.service) {
      m.service = Service.fromProto(proto.service);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.service !== 'undefined' && this.service !== null) {
      toReturn['service'] = 'toApiJson' in this.service ? this.service.toApiJson() : this.service;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    if (typeof this.hostId !== 'undefined') {
      toReturn['hostId'] = this.hostId;
    }
    return toReturn;
  }
}
class CreateServiceResponse {
  static fromProto(proto) {
    let m = new CreateServiceResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class DeleteAvailabilityRequest {
  static fromProto(proto) {
    let m = new DeleteAvailabilityRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class DeleteGroupRequest {
  static fromProto(proto) {
    let m = new DeleteGroupRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.hostId !== 'undefined') {
      toReturn['hostId'] = this.hostId;
    }
    return toReturn;
  }
}
class DeleteMeetingTypeRequest {
  static fromProto(proto) {
    let m = new DeleteMeetingTypeRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class DeleteServiceRequest {
  static fromProto(proto) {
    let m = new DeleteServiceRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.hostId !== 'undefined') {
      toReturn['hostId'] = this.hostId;
    }
    return toReturn;
  }
}
class DoesCalendarExistRequest {
  static fromProto(proto) {
    let m = new DoesCalendarExistRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.calendarIdentifier !== 'undefined') {
      toReturn['calendarIdentifier'] = this.calendarIdentifier;
    }
    return toReturn;
  }
}
class DoesCalendarExistResponse {
  static fromProto(proto) {
    let m = new DoesCalendarExistResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.exists !== 'undefined') {
      toReturn['exists'] = this.exists;
    }
    return toReturn;
  }
}
class EnsureGroupCalendarsExistRequest {
  static fromProto(proto) {
    let m = new EnsureGroupCalendarsExistRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.externalIds !== 'undefined') {
      toReturn['externalIds'] = this.externalIds;
    }
    return toReturn;
  }
}
class EnsureGroupCalendarsExistResponse {
  static fromProto(proto) {
    let m = new EnsureGroupCalendarsExistResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.calendarIds !== 'undefined') {
      toReturn['calendarIds'] = this.calendarIds;
    }
    return toReturn;
  }
}
class EnsurePersonalCalendarExistsRequest {
  static fromProto(proto) {
    let m = new EnsurePersonalCalendarExistsRequest();
    m = Object.assign(m, proto);
    if (proto.applicationContextProperties) {
      m.applicationContextProperties = Object.keys(proto.applicationContextProperties).reduce((obj, k) => {
        obj[k] = proto.applicationContextProperties[k];
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.applicationContextProperties !== 'undefined' && this.applicationContextProperties !== null) {
      toReturn['applicationContextProperties'] = 'toApiJson' in this.applicationContextProperties ? this.applicationContextProperties.toApiJson() : this.applicationContextProperties;
    }
    return toReturn;
  }
}
class EnsurePersonalCalendarExistsResponse {
  static fromProto(proto) {
    let m = new EnsurePersonalCalendarExistsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.calendarId !== 'undefined') {
      toReturn['calendarId'] = this.calendarId;
    }
    return toReturn;
  }
}
class EnsureSessionEventCalendarsExistRequest {
  static fromProto(proto) {
    let m = new EnsureSessionEventCalendarsExistRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    return toReturn;
  }
}
class EnsureSessionEventCalendarsExistResponse {
  static fromProto(proto) {
    let m = new EnsureSessionEventCalendarsExistResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.calendarId !== 'undefined') {
      toReturn['calendarId'] = this.calendarId;
    }
    return toReturn;
  }
}
class ListBookedMeetingsRequestFilters {
  static fromProto(proto) {
    let m = new ListBookedMeetingsRequestFilters();
    m = Object.assign(m, proto);
    if (proto.timeSpan) {
      m.timeSpan = DateRange.fromProto(proto.timeSpan);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.meetingTypeIds !== 'undefined') {
      toReturn['meetingTypeIds'] = this.meetingTypeIds;
    }
    if (typeof this.hostId !== 'undefined') {
      toReturn['hostId'] = this.hostId;
    }
    if (typeof this.timeSpan !== 'undefined' && this.timeSpan !== null) {
      toReturn['timeSpan'] = 'toApiJson' in this.timeSpan ? this.timeSpan.toApiJson() : this.timeSpan;
    }
    return toReturn;
  }
}
class ListAvailabilityRequestFilters {
  static fromProto(proto) {
    let m = new ListAvailabilityRequestFilters();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hostId !== 'undefined') {
      toReturn['hostId'] = this.hostId;
    }
    if (typeof this.meetingTypeId !== 'undefined') {
      toReturn['meetingTypeId'] = this.meetingTypeId;
    }
    return toReturn;
  }
}
class GetEntityAssociationRequest {
  static fromProto(proto) {
    let m = new GetEntityAssociationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.entityId !== 'undefined') {
      toReturn['entityId'] = this.entityId;
    }
    return toReturn;
  }
}
class GetEntityAssociationResponse {
  static fromProto(proto) {
    let m = new GetEntityAssociationResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.groups !== 'undefined') {
      toReturn['groups'] = this.groups;
    }
    if (typeof this.services !== 'undefined') {
      toReturn['services'] = this.services;
    }
    return toReturn;
  }
}
class GetHostMeetingRequest {
  static fromProto(proto) {
    let m = new GetHostMeetingRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.meetingId !== 'undefined') {
      toReturn['meetingId'] = this.meetingId;
    }
    if (typeof this.location !== 'undefined') {
      toReturn['location'] = this.location;
    }
    return toReturn;
  }
}
class GetHostMeetingResponse {
  static fromProto(proto) {
    let m = new GetHostMeetingResponse();
    m = Object.assign(m, proto);
    if (proto.meeting) {
      m.meeting = Meeting.fromProto(proto.meeting);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.meeting !== 'undefined' && this.meeting !== null) {
      toReturn['meeting'] = 'toApiJson' in this.meeting ? this.meeting.toApiJson() : this.meeting;
    }
    return toReturn;
  }
}
class GetHostPreferencesRequest {
  static fromProto(proto) {
    let m = new GetHostPreferencesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hostId !== 'undefined') {
      toReturn['hostId'] = this.hostId;
    }
    return toReturn;
  }
}
class GetHostPreferencesResponse {
  static fromProto(proto) {
    let m = new GetHostPreferencesResponse();
    m = Object.assign(m, proto);
    if (proto.preferences) {
      m.preferences = Preferences.fromProto(proto.preferences);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.preferences !== 'undefined' && this.preferences !== null) {
      toReturn['preferences'] = 'toApiJson' in this.preferences ? this.preferences.toApiJson() : this.preferences;
    }
    return toReturn;
  }
}
class GetHostsForCalendarRequest {
  static fromProto(proto) {
    let m = new GetHostsForCalendarRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.calendarId !== 'undefined') {
      toReturn['calendarId'] = this.calendarId;
    }
    if (typeof this.timezone !== 'undefined') {
      toReturn['timezone'] = this.timezone;
    }
    return toReturn;
  }
}
class GetHostsForCalendarResponse {
  static fromProto(proto) {
    let m = new GetHostsForCalendarResponse();
    m = Object.assign(m, proto);
    if (proto.hostUsers) {
      m.hostUsers = proto.hostUsers.map(HostUser.fromProto);
    }
    if (proto.hostUserAvailabilityRule) {
      m.hostUserAvailabilityRule = Object.keys(proto.hostUserAvailabilityRule).reduce((obj, k) => {
        obj[k] = AvailabilityRuleList.fromProto(proto.hostUserAvailabilityRule[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hostUsers !== 'undefined' && this.hostUsers !== null) {
      toReturn['hostUsers'] = 'toApiJson' in this.hostUsers ? this.hostUsers.toApiJson() : this.hostUsers;
    }
    if (typeof this.hostUserAvailabilityRule !== 'undefined' && this.hostUserAvailabilityRule !== null) {
      toReturn['hostUserAvailabilityRule'] = 'toApiJson' in this.hostUserAvailabilityRule ? this.hostUserAvailabilityRule.toApiJson() : this.hostUserAvailabilityRule;
    }
    return toReturn;
  }
}
class GetMeetingTypesForCalendarsRequest {
  static fromProto(proto) {
    let m = new GetMeetingTypesForCalendarsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.calendarIds !== 'undefined') {
      toReturn['calendarIds'] = this.calendarIds;
    }
    return toReturn;
  }
}
class GetMeetingTypesForCalendarsResponse {
  static fromProto(proto) {
    let m = new GetMeetingTypesForCalendarsResponse();
    m = Object.assign(m, proto);
    if (proto.calendarMeetingTypesMap) {
      m.calendarMeetingTypesMap = Object.keys(proto.calendarMeetingTypesMap).reduce((obj, k) => {
        obj[k] = MeetingTypeList.fromProto(proto.calendarMeetingTypesMap[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.calendarMeetingTypesMap !== 'undefined' && this.calendarMeetingTypesMap !== null) {
      toReturn['calendarMeetingTypesMap'] = 'toApiJson' in this.calendarMeetingTypesMap ? this.calendarMeetingTypesMap.toApiJson() : this.calendarMeetingTypesMap;
    }
    return toReturn;
  }
}
class HostBookMeetingRequest {
  static fromProto(proto) {
    let m = new HostBookMeetingRequest();
    m = Object.assign(m, proto);
    if (proto.meetingSource) {
      m.meetingSource = enumStringToValue$2(MeetingSource, proto.meetingSource);
    }
    if (proto.timeSlot) {
      m.timeSlot = DateRange.fromProto(proto.timeSlot);
    }
    if (proto.attendees) {
      m.attendees = proto.attendees.map(Contact.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.meetingSource !== 'undefined') {
      toReturn['meetingSource'] = this.meetingSource;
    }
    if (typeof this.calendarId !== 'undefined') {
      toReturn['calendarId'] = this.calendarId;
    }
    if (typeof this.meetingTypeId !== 'undefined') {
      toReturn['meetingTypeId'] = this.meetingTypeId;
    }
    if (typeof this.timeSlot !== 'undefined' && this.timeSlot !== null) {
      toReturn['timeSlot'] = 'toApiJson' in this.timeSlot ? this.timeSlot.toApiJson() : this.timeSlot;
    }
    if (typeof this.attendees !== 'undefined' && this.attendees !== null) {
      toReturn['attendees'] = 'toApiJson' in this.attendees ? this.attendees.toApiJson() : this.attendees;
    }
    if (typeof this.topic !== 'undefined') {
      toReturn['topic'] = this.topic;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
class HostBookMeetingResponse {
  static fromProto(proto) {
    let m = new HostBookMeetingResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.meetingId !== 'undefined') {
      toReturn['meetingId'] = this.meetingId;
    }
    return toReturn;
  }
}
class HostBookSessionRequest {
  static fromProto(proto) {
    let m = new HostBookSessionRequest();
    m = Object.assign(m, proto);
    if (proto.locationType) {
      m.locationType = enumStringToValue$2(MeetingLocationType, proto.locationType);
    }
    if (proto.maxAttendees) {
      m.maxAttendees = parseInt(proto.maxAttendees, 10);
    }
    if (proto.hostUsers) {
      m.hostUsers = proto.hostUsers.map(HostUser.fromProto);
    }
    if (proto.registrationCutoff) {
      m.registrationCutoff = RegistrationCutOff.fromProto(proto.registrationCutoff);
    }
    if (proto.timeSlot) {
      m.timeSlot = DateRange.fromProto(proto.timeSlot);
    }
    if (proto.start) {
      m.start = new Date(proto.start);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.location !== 'undefined') {
      toReturn['location'] = this.location;
    }
    if (typeof this.locationType !== 'undefined') {
      toReturn['locationType'] = this.locationType;
    }
    if (typeof this.duration !== 'undefined') {
      toReturn['duration'] = this.duration;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.maxAttendees !== 'undefined') {
      toReturn['maxAttendees'] = this.maxAttendees;
    }
    if (typeof this.logoUrl !== 'undefined') {
      toReturn['logoUrl'] = this.logoUrl;
    }
    if (typeof this.hostUsers !== 'undefined' && this.hostUsers !== null) {
      toReturn['hostUsers'] = 'toApiJson' in this.hostUsers ? this.hostUsers.toApiJson() : this.hostUsers;
    }
    if (typeof this.registrationCutoff !== 'undefined' && this.registrationCutoff !== null) {
      toReturn['registrationCutoff'] = 'toApiJson' in this.registrationCutoff ? this.registrationCutoff.toApiJson() : this.registrationCutoff;
    }
    if (typeof this.timeSlot !== 'undefined' && this.timeSlot !== null) {
      toReturn['timeSlot'] = 'toApiJson' in this.timeSlot ? this.timeSlot.toApiJson() : this.timeSlot;
    }
    if (typeof this.sessionSlug !== 'undefined') {
      toReturn['sessionSlug'] = this.sessionSlug;
    }
    if (typeof this.start !== 'undefined' && this.start !== null) {
      toReturn['start'] = 'toApiJson' in this.start ? this.start.toApiJson() : this.start;
    }
    if (typeof this.meetingTypeId !== 'undefined') {
      toReturn['meetingTypeId'] = this.meetingTypeId;
    }
    if (typeof this.hostId !== 'undefined') {
      toReturn['hostId'] = this.hostId;
    }
    if (typeof this.calendarId !== 'undefined') {
      toReturn['calendarId'] = this.calendarId;
    }
    return toReturn;
  }
}
class HostBookSessionResponse {
  static fromProto(proto) {
    let m = new HostBookSessionResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.meetingId !== 'undefined') {
      toReturn['meetingId'] = this.meetingId;
    }
    if (typeof this.bookingUrl !== 'undefined') {
      toReturn['bookingUrl'] = this.bookingUrl;
    }
    return toReturn;
  }
}
class HostDeleteAttendeesRequest {
  static fromProto(proto) {
    let m = new HostDeleteAttendeesRequest();
    m = Object.assign(m, proto);
    if (proto.emailsToDelete) {
      m.emailsToDelete = proto.emailsToDelete.map(EmailsToDelete.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.meetingId !== 'undefined') {
      toReturn['meetingId'] = this.meetingId;
    }
    if (typeof this.emailsToDelete !== 'undefined' && this.emailsToDelete !== null) {
      toReturn['emailsToDelete'] = 'toApiJson' in this.emailsToDelete ? this.emailsToDelete.toApiJson() : this.emailsToDelete;
    }
    return toReturn;
  }
}
class HostDetails {
  static fromProto(proto) {
    let m = new HostDetails();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hostId !== 'undefined') {
      toReturn['hostId'] = this.hostId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class HostGetCalendarRequest {
  static fromProto(proto) {
    let m = new HostGetCalendarRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.calendarId !== 'undefined') {
      toReturn['calendarId'] = this.calendarId;
    }
    return toReturn;
  }
}
class HostGetCalendarResponse {
  static fromProto(proto) {
    let m = new HostGetCalendarResponse();
    m = Object.assign(m, proto);
    if (proto.calendar) {
      m.calendar = Calendar.fromProto(proto.calendar);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.calendar !== 'undefined' && this.calendar !== null) {
      toReturn['calendar'] = 'toApiJson' in this.calendar ? this.calendar.toApiJson() : this.calendar;
    }
    return toReturn;
  }
}
class HostGetMeetingTypeRequest {
  static fromProto(proto) {
    let m = new HostGetMeetingTypeRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.calendarSlug !== 'undefined') {
      toReturn['calendarSlug'] = this.calendarSlug;
    }
    if (typeof this.meetingTypeSlug !== 'undefined') {
      toReturn['meetingTypeSlug'] = this.meetingTypeSlug;
    }
    return toReturn;
  }
}
class HostGetMeetingTypeResponse {
  static fromProto(proto) {
    let m = new HostGetMeetingTypeResponse();
    m = Object.assign(m, proto);
    if (proto.meetingType) {
      m.meetingType = MeetingType.fromProto(proto.meetingType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.meetingType !== 'undefined' && this.meetingType !== null) {
      toReturn['meetingType'] = 'toApiJson' in this.meetingType ? this.meetingType.toApiJson() : this.meetingType;
    }
    return toReturn;
  }
}
class HostListMeetingTypesRequest {
  static fromProto(proto) {
    let m = new HostListMeetingTypesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hostId !== 'undefined') {
      toReturn['hostId'] = this.hostId;
    }
    return toReturn;
  }
}
class HostListMeetingTypesResponse {
  static fromProto(proto) {
    let m = new HostListMeetingTypesResponse();
    m = Object.assign(m, proto);
    if (proto.meetingTypes) {
      m.meetingTypes = proto.meetingTypes.map(MeetingType.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.meetingTypes !== 'undefined' && this.meetingTypes !== null) {
      toReturn['meetingTypes'] = 'toApiJson' in this.meetingTypes ? this.meetingTypes.toApiJson() : this.meetingTypes;
    }
    return toReturn;
  }
}
class GetHostsForCalendarResponseHostUserAvailabilityRuleEntry {
  static fromProto(proto) {
    let m = new GetHostsForCalendarResponseHostUserAvailabilityRuleEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = AvailabilityRuleList.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class IsCalendarConfiguredRequest {
  static fromProto(proto) {
    let m = new IsCalendarConfiguredRequest();
    m = Object.assign(m, proto);
    if (proto.applicationContextProperties) {
      m.applicationContextProperties = Object.keys(proto.applicationContextProperties).reduce((obj, k) => {
        obj[k] = proto.applicationContextProperties[k];
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.applicationContextProperties !== 'undefined' && this.applicationContextProperties !== null) {
      toReturn['applicationContextProperties'] = 'toApiJson' in this.applicationContextProperties ? this.applicationContextProperties.toApiJson() : this.applicationContextProperties;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
class IsCalendarConfiguredResponse {
  static fromProto(proto) {
    let m = new IsCalendarConfiguredResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.isConfigured !== 'undefined') {
      toReturn['isConfigured'] = this.isConfigured;
    }
    if (typeof this.calendarIds !== 'undefined') {
      toReturn['calendarIds'] = this.calendarIds;
    }
    return toReturn;
  }
}
class IsHostConfiguredRequest {
  static fromProto(proto) {
    let m = new IsHostConfiguredRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hostId !== 'undefined') {
      toReturn['hostId'] = this.hostId;
    }
    return toReturn;
  }
}
class IsHostConfiguredResponse {
  static fromProto(proto) {
    let m = new IsHostConfiguredResponse();
    m = Object.assign(m, proto);
    if (proto.onBoardingState) {
      m.onBoardingState = enumStringToValue$2(OnBoardingState, proto.onBoardingState);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.isConfigured !== 'undefined') {
      toReturn['isConfigured'] = this.isConfigured;
    }
    if (typeof this.onBoardingState !== 'undefined') {
      toReturn['onBoardingState'] = this.onBoardingState;
    }
    return toReturn;
  }
}
class ListAttendeesRequest {
  static fromProto(proto) {
    let m = new ListAttendeesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.meetingId !== 'undefined') {
      toReturn['meetingId'] = this.meetingId;
    }
    return toReturn;
  }
}
class ListAttendeesResponse {
  static fromProto(proto) {
    let m = new ListAttendeesResponse();
    m = Object.assign(m, proto);
    if (proto.attendees) {
      m.attendees = proto.attendees.map(SessionAttendees.fromProto);
    }
    if (proto.metadata) {
      m.metadata = PagedResponseMetadata.fromProto(proto.metadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.attendees !== 'undefined' && this.attendees !== null) {
      toReturn['attendees'] = 'toApiJson' in this.attendees ? this.attendees.toApiJson() : this.attendees;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    return toReturn;
  }
}
class ListAvailabilityRequest {
  static fromProto(proto) {
    let m = new ListAvailabilityRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    if (proto.filters) {
      m.filters = ListAvailabilityRequestFilters.fromProto(proto.filters);
    }
    if (proto.timeZone) {
      m.timeZone = TimeZone.fromProto(proto.timeZone);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.timeZone !== 'undefined' && this.timeZone !== null) {
      toReturn['timeZone'] = 'toApiJson' in this.timeZone ? this.timeZone.toApiJson() : this.timeZone;
    }
    return toReturn;
  }
}
class ListAvailabilityResponse {
  static fromProto(proto) {
    let m = new ListAvailabilityResponse();
    m = Object.assign(m, proto);
    if (proto.availabilityRules) {
      m.availabilityRules = proto.availabilityRules.map(AvailabilityRule.fromProto);
    }
    if (proto.metadata) {
      m.metadata = PagedResponseMetadata.fromProto(proto.metadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.availabilityRules !== 'undefined' && this.availabilityRules !== null) {
      toReturn['availabilityRules'] = 'toApiJson' in this.availabilityRules ? this.availabilityRules.toApiJson() : this.availabilityRules;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    return toReturn;
  }
}
class ListBookedMeetingsRequest {
  static fromProto(proto) {
    let m = new ListBookedMeetingsRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListBookedMeetingsRequestFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    if (proto.timeZone) {
      m.timeZone = TimeZone.fromProto(proto.timeZone);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.timeZone !== 'undefined' && this.timeZone !== null) {
      toReturn['timeZone'] = 'toApiJson' in this.timeZone ? this.timeZone.toApiJson() : this.timeZone;
    }
    return toReturn;
  }
}
class ListBookedMeetingsResponse {
  static fromProto(proto) {
    let m = new ListBookedMeetingsResponse();
    m = Object.assign(m, proto);
    if (proto.meetings) {
      m.meetings = proto.meetings.map(Meeting.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.meetings !== 'undefined' && this.meetings !== null) {
      toReturn['meetings'] = 'toApiJson' in this.meetings ? this.meetings.toApiJson() : this.meetings;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListGroupsRequest {
  static fromProto(proto) {
    let m = new ListGroupsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hostId !== 'undefined') {
      toReturn['hostId'] = this.hostId;
    }
    return toReturn;
  }
}
class ListGroupsResponse {
  static fromProto(proto) {
    let m = new ListGroupsResponse();
    m = Object.assign(m, proto);
    if (proto.groups) {
      m.groups = proto.groups.map(Group.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.groups !== 'undefined' && this.groups !== null) {
      toReturn['groups'] = 'toApiJson' in this.groups ? this.groups.toApiJson() : this.groups;
    }
    return toReturn;
  }
}
class ListServicesRequest {
  static fromProto(proto) {
    let m = new ListServicesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hostId !== 'undefined') {
      toReturn['hostId'] = this.hostId;
    }
    return toReturn;
  }
}
class ListServicesResponse {
  static fromProto(proto) {
    let m = new ListServicesResponse();
    m = Object.assign(m, proto);
    if (proto.services) {
      m.services = proto.services.map(Service.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.services !== 'undefined' && this.services !== null) {
      toReturn['services'] = 'toApiJson' in this.services ? this.services.toApiJson() : this.services;
    }
    return toReturn;
  }
}
class Meeting {
  static fromProto(proto) {
    let m = new Meeting();
    m = Object.assign(m, proto);
    if (proto.start) {
      m.start = new Date(proto.start);
    }
    if (proto.end) {
      m.end = new Date(proto.end);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.attendees) {
      m.attendees = proto.attendees.map(Attendee.fromProto);
    }
    if (proto.formAnswers) {
      m.formAnswers = Answers.fromProto(proto.formAnswers);
    }
    if (proto.metadata) {
      m.metadata = Object.keys(proto.metadata).reduce((obj, k) => {
        obj[k] = proto.metadata[k];
        return obj;
      }, {});
    }
    if (proto.attachments) {
      m.attachments = proto.attachments.map(Attachment.fromProto);
    }
    if (proto.hostDetails) {
      m.hostDetails = proto.hostDetails.map(HostDetails.fromProto);
    }
    if (proto.meetingType) {
      m.meetingType = enumStringToValue$2(TeamEventMeetingType, proto.meetingType);
    }
    if (proto.maxAttendeeCount) {
      m.maxAttendeeCount = parseInt(proto.maxAttendeeCount, 10);
    }
    if (proto.registeredAttendeeCount) {
      m.registeredAttendeeCount = parseInt(proto.registeredAttendeeCount, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.eventTypeId !== 'undefined') {
      toReturn['eventTypeId'] = this.eventTypeId;
    }
    if (typeof this.hostId !== 'undefined') {
      toReturn['hostId'] = this.hostId;
    }
    if (typeof this.start !== 'undefined' && this.start !== null) {
      toReturn['start'] = 'toApiJson' in this.start ? this.start.toApiJson() : this.start;
    }
    if (typeof this.end !== 'undefined' && this.end !== null) {
      toReturn['end'] = 'toApiJson' in this.end ? this.end.toApiJson() : this.end;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.attendees !== 'undefined' && this.attendees !== null) {
      toReturn['attendees'] = 'toApiJson' in this.attendees ? this.attendees.toApiJson() : this.attendees;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.joinMeetingUrl !== 'undefined') {
      toReturn['joinMeetingUrl'] = this.joinMeetingUrl;
    }
    if (typeof this.topic !== 'undefined') {
      toReturn['topic'] = this.topic;
    }
    if (typeof this.formAnswers !== 'undefined' && this.formAnswers !== null) {
      toReturn['formAnswers'] = 'toApiJson' in this.formAnswers ? this.formAnswers.toApiJson() : this.formAnswers;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    if (typeof this.attachments !== 'undefined' && this.attachments !== null) {
      toReturn['attachments'] = 'toApiJson' in this.attachments ? this.attachments.toApiJson() : this.attachments;
    }
    if (typeof this.location !== 'undefined') {
      toReturn['location'] = this.location;
    }
    if (typeof this.calendarId !== 'undefined') {
      toReturn['calendarId'] = this.calendarId;
    }
    if (typeof this.hostDetails !== 'undefined' && this.hostDetails !== null) {
      toReturn['hostDetails'] = 'toApiJson' in this.hostDetails ? this.hostDetails.toApiJson() : this.hostDetails;
    }
    if (typeof this.meetingType !== 'undefined') {
      toReturn['meetingType'] = this.meetingType;
    }
    if (typeof this.sessionTitle !== 'undefined') {
      toReturn['sessionTitle'] = this.sessionTitle;
    }
    if (typeof this.sessionRegistrationUrl !== 'undefined') {
      toReturn['sessionRegistrationUrl'] = this.sessionRegistrationUrl;
    }
    if (typeof this.maxAttendeeCount !== 'undefined') {
      toReturn['maxAttendeeCount'] = this.maxAttendeeCount;
    }
    if (typeof this.registeredAttendeeCount !== 'undefined') {
      toReturn['registeredAttendeeCount'] = this.registeredAttendeeCount;
    }
    if (typeof this.registrationCutoff !== 'undefined') {
      toReturn['registrationCutoff'] = this.registrationCutoff;
    }
    return toReturn;
  }
}
class MeetingTypeList {
  static fromProto(proto) {
    let m = new MeetingTypeList();
    m = Object.assign(m, proto);
    if (proto.meetingTypes) {
      m.meetingTypes = proto.meetingTypes.map(MeetingType.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.meetingTypes !== 'undefined' && this.meetingTypes !== null) {
      toReturn['meetingTypes'] = 'toApiJson' in this.meetingTypes ? this.meetingTypes.toApiJson() : this.meetingTypes;
    }
    return toReturn;
  }
}
class UpdateMeetingMetadataRequestMetadataEntry {
  static fromProto(proto) {
    let m = new UpdateMeetingMetadataRequestMetadataEntry();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class MeetingMetadataEntry {
  static fromProto(proto) {
    let m = new MeetingMetadataEntry();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class RescheduleMeetingRequest {
  static fromProto(proto) {
    let m = new RescheduleMeetingRequest();
    m = Object.assign(m, proto);
    if (proto.start) {
      m.start = new Date(proto.start);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.meetingId !== 'undefined') {
      toReturn['meetingId'] = this.meetingId;
    }
    if (typeof this.start !== 'undefined' && this.start !== null) {
      toReturn['start'] = 'toApiJson' in this.start ? this.start.toApiJson() : this.start;
    }
    return toReturn;
  }
}
class SendMeetingRequestEmailRequest {
  static fromProto(proto) {
    let m = new SendMeetingRequestEmailRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.contactId !== 'undefined') {
      toReturn['contactId'] = this.contactId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.meetingTypeId !== 'undefined') {
      toReturn['meetingTypeId'] = this.meetingTypeId;
    }
    return toReturn;
  }
}
class SessionAttendees {
  static fromProto(proto) {
    let m = new SessionAttendees();
    m = Object.assign(m, proto);
    if (proto.formAnswers) {
      m.formAnswers = Answers.fromProto(proto.formAnswers);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    if (typeof this.formAnswers !== 'undefined' && this.formAnswers !== null) {
      toReturn['formAnswers'] = 'toApiJson' in this.formAnswers ? this.formAnswers.toApiJson() : this.formAnswers;
    }
    return toReturn;
  }
}
class SetGeneralAvailabilityRequest {
  static fromProto(proto) {
    let m = new SetGeneralAvailabilityRequest();
    m = Object.assign(m, proto);
    if (proto.days) {
      m.days = proto.days.map(v => enumStringToValue$2(DayOfWeek, v));
    }
    if (proto.timeSlot) {
      m.timeSlot = TimeRange.fromProto(proto.timeSlot);
    }
    if (proto.timeZone) {
      m.timeZone = TimeZone.fromProto(proto.timeZone);
    }
    if (proto.weekdaysAvailability) {
      m.weekdaysAvailability = proto.weekdaysAvailability.map(WeekdayAvailability.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hostId !== 'undefined') {
      toReturn['hostId'] = this.hostId;
    }
    if (typeof this.meetingTypeId !== 'undefined') {
      toReturn['meetingTypeId'] = this.meetingTypeId;
    }
    if (typeof this.days !== 'undefined') {
      toReturn['days'] = this.days;
    }
    if (typeof this.timeSlot !== 'undefined' && this.timeSlot !== null) {
      toReturn['timeSlot'] = 'toApiJson' in this.timeSlot ? this.timeSlot.toApiJson() : this.timeSlot;
    }
    if (typeof this.timeZone !== 'undefined' && this.timeZone !== null) {
      toReturn['timeZone'] = 'toApiJson' in this.timeZone ? this.timeZone.toApiJson() : this.timeZone;
    }
    if (typeof this.weekdaysAvailability !== 'undefined' && this.weekdaysAvailability !== null) {
      toReturn['weekdaysAvailability'] = 'toApiJson' in this.weekdaysAvailability ? this.weekdaysAvailability.toApiJson() : this.weekdaysAvailability;
    }
    return toReturn;
  }
}
class UpdateAvailabilityRequest {
  static fromProto(proto) {
    let m = new UpdateAvailabilityRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class UpdateCalendarRequest {
  static fromProto(proto) {
    let m = new UpdateCalendarRequest();
    m = Object.assign(m, proto);
    if (proto.calendarUpdate) {
      m.calendarUpdate = Calendar.fromProto(proto.calendarUpdate);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.calendarId !== 'undefined') {
      toReturn['calendarId'] = this.calendarId;
    }
    if (typeof this.calendarUpdate !== 'undefined' && this.calendarUpdate !== null) {
      toReturn['calendarUpdate'] = 'toApiJson' in this.calendarUpdate ? this.calendarUpdate.toApiJson() : this.calendarUpdate;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpdateGroupRequest {
  static fromProto(proto) {
    let m = new UpdateGroupRequest();
    m = Object.assign(m, proto);
    if (proto.group) {
      m.group = Group.fromProto(proto.group);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.group !== 'undefined' && this.group !== null) {
      toReturn['group'] = 'toApiJson' in this.group ? this.group.toApiJson() : this.group;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    if (typeof this.hostId !== 'undefined') {
      toReturn['hostId'] = this.hostId;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class UpdateHostPreferencesRequest {
  static fromProto(proto) {
    let m = new UpdateHostPreferencesRequest();
    m = Object.assign(m, proto);
    if (proto.preferences) {
      m.preferences = Preferences.fromProto(proto.preferences);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hostId !== 'undefined') {
      toReturn['hostId'] = this.hostId;
    }
    if (typeof this.preferences !== 'undefined' && this.preferences !== null) {
      toReturn['preferences'] = 'toApiJson' in this.preferences ? this.preferences.toApiJson() : this.preferences;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpdateMeetingMetadataRequest {
  static fromProto(proto) {
    let m = new UpdateMeetingMetadataRequest();
    m = Object.assign(m, proto);
    if (proto.metadata) {
      m.metadata = Object.keys(proto.metadata).reduce((obj, k) => {
        obj[k] = proto.metadata[k];
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.meetingId !== 'undefined') {
      toReturn['meetingId'] = this.meetingId;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    return toReturn;
  }
}
class UpdateMeetingTypeRequest {
  static fromProto(proto) {
    let m = new UpdateMeetingTypeRequest();
    m = Object.assign(m, proto);
    if (proto.meetingType) {
      m.meetingType = MeetingType.fromProto(proto.meetingType);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.meetingType !== 'undefined' && this.meetingType !== null) {
      toReturn['meetingType'] = 'toApiJson' in this.meetingType ? this.meetingType.toApiJson() : this.meetingType;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    if (typeof this.hostId !== 'undefined') {
      toReturn['hostId'] = this.hostId;
    }
    return toReturn;
  }
}
class UpdateServiceRequest {
  static fromProto(proto) {
    let m = new UpdateServiceRequest();
    m = Object.assign(m, proto);
    if (proto.service) {
      m.service = Service.fromProto(proto.service);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.service !== 'undefined' && this.service !== null) {
      toReturn['service'] = 'toApiJson' in this.service ? this.service.toApiJson() : this.service;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    if (typeof this.hostId !== 'undefined') {
      toReturn['hostId'] = this.hostId;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class WeekdayAvailability {
  static fromProto(proto) {
    let m = new WeekdayAvailability();
    m = Object.assign(m, proto);
    if (proto.day) {
      m.day = enumStringToValue$2(DayOfWeek, proto.day);
    }
    if (proto.timeSlots) {
      m.timeSlots = proto.timeSlots.map(TimeRange.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.day !== 'undefined') {
      toReturn['day'] = this.day;
    }
    if (typeof this.timeSlots !== 'undefined' && this.timeSlots !== null) {
      toReturn['timeSlots'] = 'toApiJson' in this.timeSlots ? this.timeSlots.toApiJson() : this.timeSlots;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class TimeOfDay {
  static fromProto(proto) {
    let m = new TimeOfDay();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hours !== 'undefined') {
      toReturn['hours'] = this.hours;
    }
    if (typeof this.minutes !== 'undefined') {
      toReturn['minutes'] = this.minutes;
    }
    if (typeof this.seconds !== 'undefined') {
      toReturn['seconds'] = this.seconds;
    }
    if (typeof this.nanos !== 'undefined') {
      toReturn['nanos'] = this.nanos;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class DateTime {
  static fromProto(proto) {
    let m = new DateTime();
    m = Object.assign(m, proto);
    if (proto.timeZone) {
      m.timeZone = TimeZone.fromProto(proto.timeZone);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.year !== 'undefined') {
      toReturn['year'] = this.year;
    }
    if (typeof this.month !== 'undefined') {
      toReturn['month'] = this.month;
    }
    if (typeof this.day !== 'undefined') {
      toReturn['day'] = this.day;
    }
    if (typeof this.hours !== 'undefined') {
      toReturn['hours'] = this.hours;
    }
    if (typeof this.minutes !== 'undefined') {
      toReturn['minutes'] = this.minutes;
    }
    if (typeof this.seconds !== 'undefined') {
      toReturn['seconds'] = this.seconds;
    }
    if (typeof this.nanos !== 'undefined') {
      toReturn['nanos'] = this.nanos;
    }
    if (typeof this.utcOffset !== 'undefined') {
      toReturn['utcOffset'] = this.utcOffset;
    }
    if (typeof this.timeZone !== 'undefined' && this.timeZone !== null) {
      toReturn['timeZone'] = 'toApiJson' in this.timeZone ? this.timeZone.toApiJson() : this.timeZone;
    }
    return toReturn;
  }
}
class TimeZone {
  static fromProto(proto) {
    let m = new TimeZone();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    return toReturn;
  }
}

// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'meetings-api.vendasta-local.com',
  'test': '',
  'demo': 'meetings-demo.apigateway.co',
  'prod': 'meetings-prod.apigateway.co',
  'production': 'meetings-prod.apigateway.co'
};
let HostService$1 = /*#__PURE__*/(() => {
  let HostService$1 = class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  };
  HostService$1.ɵfac = function HostService$1_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService$1)();
  };
  HostService$1.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService$1,
    factory: HostService$1.ɵfac,
    providedIn: 'root'
  });
  return HostService$1;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let MeetingSourceAPIApiService = /*#__PURE__*/(() => {
  class MeetingSourceAPIApiService {
    constructor() {
      this.hostService = inject(HostService$1);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    list(r) {
      const request = r.toApiJson ? r : new MeetingSourceListRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingSourceAPI/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => MeetingSourceListResponse.fromProto(resp)));
    }
  }
  MeetingSourceAPIApiService.ɵfac = function MeetingSourceAPIApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MeetingSourceAPIApiService)();
  };
  MeetingSourceAPIApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: MeetingSourceAPIApiService,
    factory: MeetingSourceAPIApiService.ɵfac,
    providedIn: 'root'
  });
  return MeetingSourceAPIApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let ZoomApiService = /*#__PURE__*/(() => {
  class ZoomApiService {
    constructor() {
      this.hostService = inject(HostService$1);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createMeeting(r) {
      const request = r.toApiJson ? r : new CreateZoomMeetingRequest(r);
      return this.http.post(this._host + "/meetings.v1.Zoom/CreateMeeting", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateZoomMeetingResponse.fromProto(resp)));
    }
  }
  ZoomApiService.ɵfac = function ZoomApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ZoomApiService)();
  };
  ZoomApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ZoomApiService,
    factory: ZoomApiService.ɵfac,
    providedIn: 'root'
  });
  return ZoomApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let GoogleMeetApiService = /*#__PURE__*/(() => {
  class GoogleMeetApiService {
    constructor() {
      this.hostService = inject(HostService$1);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createMeeting(r) {
      const request = r.toApiJson ? r : new GoogleMeetCreateMeetingRequest(r);
      return this.http.post(this._host + "/meetings.v1.GoogleMeet/CreateMeeting", request.toApiJson(), this.apiOptions()).pipe(map(resp => GoogleMeetCreateMeetingResponse.fromProto(resp)));
    }
    listMeetings(r) {
      const request = r.toApiJson ? r : new GoogleMeetListMeetingsRequest(r);
      return this.http.post(this._host + "/meetings.v1.GoogleMeet/ListMeetings", request.toApiJson(), this.apiOptions()).pipe(map(resp => GoogleMeetListMeetingsResponse.fromProto(resp)));
    }
  }
  GoogleMeetApiService.ɵfac = function GoogleMeetApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || GoogleMeetApiService)();
  };
  GoogleMeetApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: GoogleMeetApiService,
    factory: GoogleMeetApiService.ɵfac,
    providedIn: 'root'
  });
  return GoogleMeetApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function generateMeetingPassword() {
  const zoomMaxLength = 10;
  const zoomAllowedChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@-_*';
  try {
    const ints = new Uint8Array(zoomMaxLength);
    crypto.getRandomValues(ints);
    return Array.from(ints).map(v => zoomAllowedChars.charAt(v % zoomAllowedChars.length)).join('');
  } catch (e) {
    console.error('User is probably using an unsupported browser. ' + 'Falling back to less secure password generation', e);
    return new Array(zoomMaxLength).map(() => Math.floor(Math.random() * zoomAllowedChars.length)).join('');
  }
}
let MeetingsService = /*#__PURE__*/(() => {
  class MeetingsService {
    constructor(_api, zoom, meet) {
      this._api = _api;
      this.zoom = zoom;
      this.meet = meet;
    }
    /**
     * @deprecated Use listForUser instead. This method will result in the backend grabbing the userID from the user's JWT
     * This will eventually no longer be supported because it breaks our impersonation workflows.
     */
    list(meetingSources, namespace, origin) {
      return this._api.list({
        queriedSources: meetingSources,
        namespace: namespace,
        origin: origin
      });
    }
    listForUser(iamUserId, namespace, origin, queriedSources) {
      return this._api.list({
        iamUserId: iamUserId,
        namespace: namespace,
        origin: origin,
        queriedSources: queriedSources
      });
    }
    startInstantMeeting(meetingTitle, meetingAgenda, meetingSource, gMeetAttendees) {
      const now = new Date();
      switch (meetingSource) {
        case MeetingSource.MEETING_SOURCE_INVALID:
          return throwError('Meeting source was not specified');
        case MeetingSource.MEETING_SOURCE_ZOOM:
          const req = createZoomInstantMeetingRequest(meetingTitle, now, meetingAgenda);
          return this.zoom.createMeeting(req).pipe(map(resp => ({
            url: resp.joinUrl,
            password: resp.password,
            joinURL: resp.joinUrl
          })));
        case MeetingSource.MEETING_SOURCE_GOOGLE_MEET:
          if (!gMeetAttendees) {
            return throwError('Attendees are required to start a Meet Hangout');
          }
          const meetReq = createMeetInstantMeetingRequest(meetingTitle, now, gMeetAttendees);
          return this.meet.createMeeting(meetReq).pipe(map(resp => ({
            url: resp.meeting.hangoutLink,
            joinURL: resp.meeting.hangoutLink
          })));
        default:
          // eslint-disable-next-line
          return throwError(`Unrecognized meeting source ${meetingSource}`);
      }
    }
    createBasicZoomScheduledMeeting(topic, agenda, startDateTime, duration, timezone, meetingPassword) {
      const req = new CreateZoomMeetingRequest({
        topic: topic,
        type: ZoomMeetingType.ZOOM_MEETING_TYPE_SCHEDULED,
        startTime: startDateTime,
        duration: duration,
        timezone: timezone,
        password: meetingPassword ? meetingPassword : generateMeetingPassword(),
        agenda: agenda,
        settings: {
          joinBeforeHost: true,
          enforceLogin: false
        },
        recurrence: {
          type: ZoomMeetingRecurrenceType.ZOOM_MEETING_RECURRENCE_TYPE_DAILY
        }
      });
      return this.zoom.createMeeting(req);
    }
    createBasicGoogleMeeting(topic, agenda, startDateTime, endDateTime, timezone, attendees) {
      const req = new GoogleMeetCreateMeetingRequest({
        meeting: {
          attendees: attendees,
          description: agenda,
          start: {
            dateTime: startDateTime,
            timeZone: timezone
          },
          end: {
            dateTime: endDateTime,
            timeZone: timezone
          },
          summary: topic
        }
      });
      return this.meet.createMeeting(req);
    }
  }
  MeetingsService.ɵfac = function MeetingsService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MeetingsService)(i0.ɵɵinject(MeetingSourceAPIApiService), i0.ɵɵinject(ZoomApiService), i0.ɵɵinject(GoogleMeetApiService));
  };
  MeetingsService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: MeetingsService,
    factory: MeetingsService.ɵfac,
    providedIn: 'root'
  });
  return MeetingsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function createZoomInstantMeetingRequest(meetingTitle, now, meetingAgenda) {
  const recurrence = {
    type: ZoomMeetingRecurrenceType.ZOOM_MEETING_RECURRENCE_TYPE_DAILY,
    repeatInterval: 0
  };
  const req = {
    topic: meetingTitle,
    type: ZoomMeetingType.ZOOM_MEETING_TYPE_INSTANT,
    startTime: now.toISOString(),
    duration: undefined,
    timezone: 'UTC',
    password: generateMeetingPassword(),
    agenda: meetingAgenda,
    trackingFields: [],
    recurrence: recurrence,
    settings: undefined // Only used with recurring meetings
  };
  return new CreateZoomMeetingRequest(req);
}
function createMeetInstantMeetingRequest(meetingTitle, startDateTime, attendees) {
  const start = {
    dateTime: startDateTime.toISOString(),
    timeZone: 'UTC'
  };
  const endTime = new Date(startDateTime.setMinutes(startDateTime.getMinutes() + 30));
  const end = {
    dateTime: endTime.toISOString(),
    timeZone: 'UTC'
  };
  const conferenceData = {
    createRequest: {
      requestId: 'instant-meet-meeting'
    },
    conferenceSolution: {
      key: {
        type: 'eventHangout'
      }
    }
  };
  const meeting = {
    summary: meetingTitle,
    start: start,
    end: end,
    conferenceData: conferenceData,
    attendees: attendees
  };
  const req = {
    meeting: meeting
  };
  return new GoogleMeetCreateMeetingRequest(req);
}

// *********************************
let MeetingGuestApiService = /*#__PURE__*/(() => {
  class MeetingGuestApiService {
    constructor() {
      this.hostService = inject(HostService$1);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    listMeetingTypes(r) {
      const request = r.toApiJson ? r : new ListMeetingTypesRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingGuest/ListMeetingTypes", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListMeetingTypesResponse.fromProto(resp)));
    }
    getMeetingType(r) {
      const request = r.toApiJson ? r : new GetMeetingTypeRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingGuest/GetMeetingType", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMeetingTypeResponse.fromProto(resp)));
    }
    listAvailableTimeSlots(r) {
      const request = r.toApiJson ? r : new ListAvailableTimeSlotsRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingGuest/ListAvailableTimeSlots", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAvailableTimeSlotsResponse.fromProto(resp)));
    }
    bookMeeting(r) {
      const request = r.toApiJson ? r : new BookMeetingRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingGuest/BookMeeting", request.toApiJson(), this.apiOptions()).pipe(map(resp => BookMeetingResponse.fromProto(resp)));
    }
    cancelMeeting(r) {
      const request = r.toApiJson ? r : new GuestCancelMeetingRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingGuest/CancelMeeting", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    rescheduleMeeting(r) {
      const request = r.toApiJson ? r : new GuestRescheduleMeetingRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingGuest/RescheduleMeeting", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getGuestBookedMeeting(r) {
      const request = r.toApiJson ? r : new GuestGetBookedMeetingRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingGuest/GetGuestBookedMeeting", request.toApiJson(), this.apiOptions()).pipe(map(resp => GuestGetBookedMeetingResponse.fromProto(resp)));
    }
    getCalendar(r) {
      const request = r.toApiJson ? r : new GetCalendarRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingGuest/GetCalendar", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetCalendarResponse.fromProto(resp)));
    }
    getHost(r) {
      const request = r.toApiJson ? r : new GetHostRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingGuest/GetHost", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetHostResponse.fromProto(resp)));
    }
    getGroup(r) {
      const request = r.toApiJson ? r : new GetGroupRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingGuest/GetGroup", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetGroupResponse.fromProto(resp)));
    }
    isHostConfigured(r) {
      const request = r.toApiJson ? r : new GuestIsHostConfiguredRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingGuest/IsHostConfigured", request.toApiJson(), this.apiOptions()).pipe(map(resp => GuestIsHostConfiguredResponse.fromProto(resp)));
    }
    getService(r) {
      const request = r.toApiJson ? r : new GetServiceRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingGuest/GetService", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetServiceResponse.fromProto(resp)));
    }
    registerSession(r) {
      const request = r.toApiJson ? r : new RegisterSessionRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingGuest/RegisterSession", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getSessionMeetingInfo(r) {
      const request = r.toApiJson ? r : new GetSessionMeetingRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingGuest/GetSessionMeetingRequest", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSessionMeetingResponse.fromProto(resp)));
    }
  }
  MeetingGuestApiService.ɵfac = function MeetingGuestApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MeetingGuestApiService)();
  };
  MeetingGuestApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: MeetingGuestApiService,
    factory: MeetingGuestApiService.ɵfac,
    providedIn: 'root'
  });
  return MeetingGuestApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let MeetingHostApiService = /*#__PURE__*/(() => {
  class MeetingHostApiService {
    constructor() {
      this.hostService = inject(HostService$1);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    buildHostId(r) {
      const request = r.toApiJson ? r : new BuildHostIdRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/BuildHostId", request.toApiJson(), this.apiOptions()).pipe(map(resp => BuildHostIdResponse.fromProto(resp)));
    }
    doesCalendarExist(r) {
      const request = r.toApiJson ? r : new DoesCalendarExistRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/DoesCalendarExist", request.toApiJson(), this.apiOptions()).pipe(map(resp => DoesCalendarExistResponse.fromProto(resp)));
    }
    createCalendar(r) {
      const request = r.toApiJson ? r : new CreateCalendarRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/CreateCalendar", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateCalendarResponse.fromProto(resp)));
    }
    updateCalendar(r) {
      const request = r.toApiJson ? r : new UpdateCalendarRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/UpdateCalendar", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getCalendar(r) {
      const request = r.toApiJson ? r : new HostGetCalendarRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/GetCalendar", request.toApiJson(), this.apiOptions()).pipe(map(resp => HostGetCalendarResponse.fromProto(resp)));
    }
    ensurePersonalCalendarExists(r) {
      const request = r.toApiJson ? r : new EnsurePersonalCalendarExistsRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/EnsurePersonalCalendarExists", request.toApiJson(), this.apiOptions()).pipe(map(resp => EnsurePersonalCalendarExistsResponse.fromProto(resp)));
    }
    ensureGroupCalendarsExist(r) {
      const request = r.toApiJson ? r : new EnsureGroupCalendarsExistRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/EnsureGroupCalendarsExist", request.toApiJson(), this.apiOptions()).pipe(map(resp => EnsureGroupCalendarsExistResponse.fromProto(resp)));
    }
    ensureSessionEventCalendarsExist(r) {
      const request = r.toApiJson ? r : new EnsureSessionEventCalendarsExistRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/EnsureSessionEventCalendarsExist", request.toApiJson(), this.apiOptions()).pipe(map(resp => EnsureSessionEventCalendarsExistResponse.fromProto(resp)));
    }
    getHostsForCalendar(r) {
      const request = r.toApiJson ? r : new GetHostsForCalendarRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/GetHostsForCalendar", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetHostsForCalendarResponse.fromProto(resp)));
    }
    getMeetingTypesForCalendars(r) {
      const request = r.toApiJson ? r : new GetMeetingTypesForCalendarsRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/GetMeetingTypesForCalendars", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMeetingTypesForCalendarsResponse.fromProto(resp)));
    }
    listAvailability(r) {
      const request = r.toApiJson ? r : new ListAvailabilityRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/ListAvailability", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAvailabilityResponse.fromProto(resp)));
    }
    bookMeeting(r) {
      const request = r.toApiJson ? r : new HostBookMeetingRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/BookMeeting", request.toApiJson(), this.apiOptions()).pipe(map(resp => HostBookMeetingResponse.fromProto(resp)));
    }
    getHostMeeting(r) {
      const request = r.toApiJson ? r : new GetHostMeetingRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/GetHostMeeting", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetHostMeetingResponse.fromProto(resp)));
    }
    listBookedMeetings(r) {
      const request = r.toApiJson ? r : new ListBookedMeetingsRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/ListBookedMeetings", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListBookedMeetingsResponse.fromProto(resp)));
    }
    cancelMeeting(r) {
      const request = r.toApiJson ? r : new CancelMeetingRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/CancelMeeting", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    rescheduleMeeting(r) {
      const request = r.toApiJson ? r : new RescheduleMeetingRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/RescheduleMeeting", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updateMeetingMetadata(r) {
      const request = r.toApiJson ? r : new UpdateMeetingMetadataRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/UpdateMeetingMetadata", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    setGeneralAvailability(r) {
      const request = r.toApiJson ? r : new SetGeneralAvailabilityRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/SetGeneralAvailability", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    createAvailability(r) {
      const request = r.toApiJson ? r : new CreateAvailabilityRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/CreateAvailability", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateAvailabilityResponse.fromProto(resp)));
    }
    updateAvailability(r) {
      const request = r.toApiJson ? r : new UpdateAvailabilityRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/UpdateAvailability", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteAvailability(r) {
      const request = r.toApiJson ? r : new DeleteAvailabilityRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/DeleteAvailability", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    isHostConfigured(r) {
      const request = r.toApiJson ? r : new IsHostConfiguredRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/IsHostConfigured", request.toApiJson(), this.apiOptions()).pipe(map(resp => IsHostConfiguredResponse.fromProto(resp)));
    }
    getHostPreferences(r) {
      const request = r.toApiJson ? r : new GetHostPreferencesRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/GetHostPreferences", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetHostPreferencesResponse.fromProto(resp)));
    }
    updateHostPreferences(r) {
      const request = r.toApiJson ? r : new UpdateHostPreferencesRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/UpdateHostPreferences", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getMeetingType(r) {
      const request = r.toApiJson ? r : new HostGetMeetingTypeRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/GetMeetingType", request.toApiJson(), this.apiOptions()).pipe(map(resp => HostGetMeetingTypeResponse.fromProto(resp)));
    }
    listMeetingTypes(r) {
      const request = r.toApiJson ? r : new HostListMeetingTypesRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/ListMeetingTypes", request.toApiJson(), this.apiOptions()).pipe(map(resp => HostListMeetingTypesResponse.fromProto(resp)));
    }
    createMeetingType(r) {
      const request = r.toApiJson ? r : new CreateMeetingTypeRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/CreateMeetingType", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateMeetingTypeResponse.fromProto(resp)));
    }
    updateMeetingType(r) {
      const request = r.toApiJson ? r : new UpdateMeetingTypeRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/UpdateMeetingType", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteMeetingType(r) {
      const request = r.toApiJson ? r : new DeleteMeetingTypeRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/DeleteMeetingType", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    createDefaultMeetingTypes(r) {
      const request = r.toApiJson ? r : new CreateDefaultMeetingTypesRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/CreateDefaultMeetingTypes", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    sendMeetingRequestEmail(r) {
      const request = r.toApiJson ? r : new SendMeetingRequestEmailRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/SendMeetingRequestEmail", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    isCalendarConfigured(r) {
      const request = r.toApiJson ? r : new IsCalendarConfiguredRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/IsCalendarConfigured", request.toApiJson(), this.apiOptions()).pipe(map(resp => IsCalendarConfiguredResponse.fromProto(resp)));
    }
    createGroup(r) {
      const request = r.toApiJson ? r : new CreateGroupRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/CreateGroup", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateGroupResponse.fromProto(resp)));
    }
    updateGroup(r) {
      const request = r.toApiJson ? r : new UpdateGroupRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/UpdateGroup", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteGroup(r) {
      const request = r.toApiJson ? r : new DeleteGroupRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/DeleteGroup", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listGroups(r) {
      const request = r.toApiJson ? r : new ListGroupsRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/ListGroups", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListGroupsResponse.fromProto(resp)));
    }
    createService(r) {
      const request = r.toApiJson ? r : new CreateServiceRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/CreateService", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateServiceResponse.fromProto(resp)));
    }
    updateService(r) {
      const request = r.toApiJson ? r : new UpdateServiceRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/UpdateService", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteService(r) {
      const request = r.toApiJson ? r : new DeleteServiceRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/DeleteService", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listServices(r) {
      const request = r.toApiJson ? r : new ListServicesRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/ListServices", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListServicesResponse.fromProto(resp)));
    }
    calendarMigration() {
      return this.http.post(this._host + "/meetings.v1.MeetingHost/CalendarMigration", {}, this.apiOptions()).pipe(map(resp => CalendarMigrationResponse.fromProto(resp)));
    }
    getGroup(r) {
      const request = r.toApiJson ? r : new GetGroupRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/GetGroup", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetGroupResponse.fromProto(resp)));
    }
    getService(r) {
      const request = r.toApiJson ? r : new GetServiceRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/GetService", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetServiceResponse.fromProto(resp)));
    }
    checkGroupOrServiceSlugExist(r) {
      const request = r.toApiJson ? r : new CheckGroupOrServiceSlugExistRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/CheckGroupOrServiceSlugExist", request.toApiJson(), this.apiOptions()).pipe(map(resp => CheckGroupOrServiceSlugExistResponse.fromProto(resp)));
    }
    hostBookMeeting(r) {
      const request = r.toApiJson ? r : new BookMeetingRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/HostBookMeeting", request.toApiJson(), this.apiOptions()).pipe(map(resp => BookMeetingResponse.fromProto(resp)));
    }
    getEntityAssociations(r) {
      const request = r.toApiJson ? r : new GetEntityAssociationRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/GetEntityAssociations", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetEntityAssociationResponse.fromProto(resp)));
    }
    hostBookSession(r) {
      const request = r.toApiJson ? r : new HostBookSessionRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/HostBookSession", request.toApiJson(), this.apiOptions()).pipe(map(resp => HostBookSessionResponse.fromProto(resp)));
    }
    hostDeleteAttendees(r) {
      const request = r.toApiJson ? r : new HostDeleteAttendeesRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/HostDeleteAttendees", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listAttendees(r) {
      const request = r.toApiJson ? r : new ListAttendeesRequest(r);
      return this.http.post(this._host + "/meetings.v1.MeetingHost/ListAttendees", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAttendeesResponse.fromProto(resp)));
    }
  }
  MeetingHostApiService.ɵfac = function MeetingHostApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MeetingHostApiService)();
  };
  MeetingHostApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: MeetingHostApiService,
    factory: MeetingHostApiService.ɵfac,
    providedIn: 'root'
  });
  return MeetingHostApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************

function TimeSpanFromApi(tsAPI) {
  return {
    start: tsAPI.start,
    end: tsAPI.end
  };
}
function HostFromApi(hostAPI) {
  return {
    displayName: hostAPI.displayName,
    displayProfileUrl: hostAPI.displayProfileUrl,
    displayLogoUrl: hostAPI.displayLogoUrl
  };
}

// Copied from core
var Environment = /*#__PURE__*/function (Environment) {
  Environment[Environment["LOCAL"] = 0] = "LOCAL";
  Environment[Environment["TEST"] = 1] = "TEST";
  Environment[Environment["DEMO"] = 2] = "DEMO";
  Environment[Environment["PROD"] = 3] = "PROD";
  return Environment;
}(Environment || {});
function onProduction(env) {
  return env === Environment.PROD || env === 'prod';
}
function onProductionGlobal() {
  // environment expected to be set in the app in globals.ts
  // eslint-disable-next-line
  return typeof window !== 'undefined' && window.environment === 'prod';
}

// A temporary method for building the url for a host, eventTypeId, and metadata
function getBookingUrlImplementation(req) {
  const domain = getDomainFromEnvironment(req.environment);
  const meetingType = req.meetingTypeSlug || req.meetingTypeId || '30-minutes';
  const calendarSlug = req.calendarSlug || req.calendarId;
  let url = `https://${domain}/book/${calendarSlug}/${meetingType}`;
  if (calendarSlug.startsWith("GRP-")) {
    url = `https://${domain}/group/${calendarSlug}/${meetingType}`;
  }
  if (calendarSlug.startsWith("SVS-")) {
    url = `https://${domain}/service/${calendarSlug}/${meetingType}`;
  }
  if (!req.metadata) {
    return url;
  }
  return addMetadataToBookingLink({
    link: url,
    metadata: req.metadata
  });
}
function getGeneralBookingUrlImplementation(req) {
  const url = `https://${getDomainFromEnvironment(req.environment)}/${req.calendarSlug || req.calendarId}`;
  return req.metadata ? addMetadataToBookingLink({
    link: url,
    metadata: req.metadata
  }) : url;
}
function getDomainFromEnvironment(env) {
  if (env === Environment.PROD) {
    return 'bookmenow.info';
  }
  return 'meetings-demo.apigateway.co';
}
function addMetadataToBookingLink(req) {
  if (!req.metadata) {
    return req.link;
  }
  const m = req.metadata;
  const queryParams = Object.keys(m).reduce((params, key) => {
    if (!params) {
      if (req.link.indexOf('?') >= 0) {
        return `&${key}=${m[key]}`;
      }
      return `?${key}=${m[key]}`;
    }
    return `${params}&${key}=${m[key]}`;
  }, '');
  return `${req.link}${queryParams}`;
}
function MeetingTypeFromApi(req) {
  let bookingUrl = req?.meetingTypeApi?.bookingUrl || "";
  if (bookingUrl === "") {
    bookingUrl = getBookingUrlImplementation({
      environment: req.environment,
      calendarId: req.calendarId,
      meetingTypeSlug: req.meetingTypeApi.meetingTypeSlug || req.meetingTypeApi.id || "",
      metadata: req.metadata,
      calendarSlug: req.calendarSlug
    });
  } else {
    bookingUrl = addMetadataToBookingLink({
      link: bookingUrl,
      metadata: req.metadata || {}
    });
  }
  const form = {
    ...(req.meetingTypeApi.form || {
      fields: []
    }),
    fields: (req.meetingTypeApi.form && req.meetingTypeApi.form.fields ? req.meetingTypeApi.form.fields : []).map(field => {
      return {
        ...field,
        id: field.id || "",
        label: field.label || "",
        type: field.type || FormFieldType.FORM_FIELD_TYPE_INVALID,
        required: field.required || false
      };
    })
  };
  return {
    id: req.meetingTypeApi.id || "",
    calendarId: req.meetingTypeApi.calendarId || "",
    name: req.meetingTypeApi.name || "",
    duration: req.meetingTypeApi.duration || "",
    bookingUrl: bookingUrl,
    bookingLink: req.meetingTypeApi.meetingTypeSlug || "",
    meetingTypeSlug: req.meetingTypeApi.meetingTypeSlug || "",
    description: req.meetingTypeApi.description || "",
    hexColor: req.meetingTypeApi.hexColor || "",
    form: form,
    hostUserIds: req.meetingTypeApi.hostUserIds || [],
    availabilityIncrement: req.meetingTypeApi.availabilityIncrement || -1,
    bufferDurationAfterMeeting: req.meetingTypeApi.bufferDurationAfterMeeting || 0,
    bufferDurationBeforeMeeting: req.meetingTypeApi.bufferDurationBeforeMeeting || 0,
    noticeTime: req.meetingTypeApi.noticeTime || 0,
    location: req.meetingTypeApi.location || "",
    locationGuidelines: req.meetingTypeApi.locationGuidelines || "",
    emailSubject: req.meetingTypeApi.emailSubject || "",
    emailDescription: req.meetingTypeApi.emailDescription || "",
    isPinned: req.meetingTypeApi.isPinned || false,
    CalendarType: req.meetingTypeApi.calendarType || "",
    hostUsers: req.meetingTypeApi.hostUsers || [],
    teamName: req.meetingTypeApi.teamName || "",
    isVideoLinkDisabled: req.meetingTypeApi.isVideoLinkDisabled || false,
    locationType: req.meetingTypeApi.locationType || MeetingLocationType.VIDEO,
    meetingType: req.meetingTypeApi.meetingType || TeamEventMeetingType.ROUND_ROBIN,
    dateRange: req.meetingTypeApi.dateRange || {},
    attendeeCount: req.meetingTypeApi.attendeeCount || 0,
    registrationCutoff: req.meetingTypeApi.registrationCutoff || undefined,
    sessionTitle: req.meetingTypeApi.sessionTitle || ""
  };
}
function MeetingTypeToApi(req) {
  const m = req.meetingType;
  if (!m) {
    return {};
  }
  return {
    id: m.id || undefined,
    name: m.name || undefined,
    hexColor: m.hexColor || undefined,
    meetingTypeSlug: m.meetingTypeSlug || m.bookingLink || undefined,
    calendarId: m.calendarId || undefined,
    description: m.description || undefined,
    duration: m.duration ? m.duration : undefined,
    form: m.form || undefined,
    hostUserIds: m.hostUserIds || undefined,
    availabilityIncrement: m.availabilityIncrement || undefined,
    bufferDurationAfterMeeting: m.bufferDurationAfterMeeting || 0,
    noticeTime: m.noticeTime || 0,
    location: m.location || undefined,
    locationGuidelines: m.locationGuidelines || undefined,
    emailSubject: m.emailSubject || undefined,
    emailDescription: m.emailDescription || undefined,
    isPinned: m.isPinned || undefined,
    calendarType: m.CalendarType || undefined,
    hostUsers: m.hostUsers || undefined,
    teamName: m.teamName || undefined,
    isVideoLinkDisabled: m.isVideoLinkDisabled || false,
    locationType: m.locationType || MeetingLocationType.VIDEO,
    bufferDurationBeforeMeeting: m.bufferDurationBeforeMeeting || 0,
    meetingType: m.meetingType || TeamEventMeetingType.ROUND_ROBIN,
    dateRange: m.dateRange || undefined,
    attendeeCount: m.attendeeCount || 0,
    registrationCutoff: m.registrationCutoff || undefined,
    sessionTitle: m.sessionTitle || undefined
  };
}

// These represent well-known metadata keys used for more than just tracking
var WellKnownMeetingMetadataKeys = /*#__PURE__*/function (WellKnownMeetingMetadataKeys) {
  // This is the business (AG) attached to a meeting. This is attached via sending msm_business as a query param during booking
  WellKnownMeetingMetadataKeys["BUSINESS"] = "msm_business";
  return WellKnownMeetingMetadataKeys;
}(WellKnownMeetingMetadataKeys || {});
// These are part of the standard Meeting Scheduler form.
// If you are trying to pre-fill these fields use the helper formFieldIdToMetadataParam
var WellKnownFormFieldIds = /*#__PURE__*/function (WellKnownFormFieldIds) {
  WellKnownFormFieldIds["FIRST_NAME"] = "firstName";
  WellKnownFormFieldIds["LAST_NAME"] = "lastName";
  WellKnownFormFieldIds["EMAIL"] = "email";
  WellKnownFormFieldIds["PHONE_NUMBER"] = "phoneNumber";
  WellKnownFormFieldIds["COMMENT"] = "comment";
  WellKnownFormFieldIds["INVITEE_EMAILS"] = "inviteeEmail";
  return WellKnownFormFieldIds;
}(WellKnownFormFieldIds || {});
// Converts the given id into a metadata key that can be sent on the url.
// This means the key will be used to pre-fill those form fields.
// This can also be used on fields that are not metadata to ensure they will come across in metadata.
function meetingSchedulerIdToMetadataKey(id) {
  if (!id) {
    return '';
  }
  return id.startsWith('msm_') || id.startsWith('utm_') ? id : `msm_${id}`;
}
function meetingFromApi(meetingApi) {
  return {
    id: meetingApi.id,
    eventTypeId: meetingApi.eventTypeId,
    hostId: meetingApi.hostId,
    start: meetingApi.start,
    end: meetingApi.end,
    description: meetingApi.description || '',
    joinMeetingUrl: meetingApi.joinMeetingUrl || '',
    attendees: meetingApi.attendees ? meetingApi.attendees.map(a => ({
      firstName: a.firstName,
      lastName: a.lastName,
      email: a.email,
      phoneNumber: a.phoneNumber,
      timeZone: a.timeZone,
      isPrimary: a.isPrimary || false
    })) : [],
    created: meetingApi.created,
    updated: meetingApi.updated,
    topic: meetingApi.topic,
    formAnswers: answersFromAPI(meetingApi.formAnswers),
    metadata: meetingApi.metadata || {},
    attachments: (meetingApi.attachments || []).map(a => {
      return {
        fileTitle: a.fileTitle || '',
        fileUrl: a.fileUrl || '',
        fileType: a.fileType || ''
      };
    }),
    location: meetingApi.location || '',
    calendarId: meetingApi.calendarId || '',
    hostDetails: (meetingApi.hostDetails || []).map(h => {
      return {
        hostID: h.hostId || '',
        name: h.name || ''
      };
    }),
    meetingType: meetingApi.meetingType
  };
}
function answersFromAPI(formAnswers) {
  if (!formAnswers) {
    return {
      formAnswers: []
    };
  }
  return {
    formAnswers: (formAnswers.formAnswers ? formAnswers.formAnswers : []).map(a => {
      return {
        id: a.id || '',
        label: a.label || '',
        type: a.type || FormFieldType.FORM_FIELD_TYPE_INVALID,
        answer: a.answer || []
      };
    })
  };
}
function answersToAPI(formAnswers) {
  if (!formAnswers) {
    return {
      formAnswers: []
    };
  }
  return {
    formAnswers: (formAnswers.formAnswers || []).map(a => {
      return {
        id: a.id || undefined,
        label: a.label || undefined,
        type: a.type,
        answer: a.answer || undefined
      };
    })
  };
}
class PagedResponse {
  constructor(results, nextCursor, hasMore) {
    this.results = results;
    this.nextCursor = nextCursor;
    this.hasMore = hasMore;
  }
}
function CalendarFromApi(calendarAPI) {
  return {
    id: calendarAPI.id || '',
    calendarType: calendarAPI.calendarType || CalendarType.CALENDAR_TYPE_INVALID,
    displayName: calendarAPI.displayName || '',
    displayProfileUrl: calendarAPI.displayProfileUrl || '',
    displayLogoUrl: calendarAPI.displayLogoUrl || '',
    bookingUrl: calendarAPI.bookingUrl || '',
    slug: calendarAPI.slug || '',
    externalId: calendarAPI.externalId || '',
    creatorUserId: calendarAPI.creatorUserId || '',
    hostUserIds: calendarAPI.hostUserIds || [],
    applicationContext: calendarAPI.applicationContext || {},
    encodedApplicationContext: ''
  };
}
// From meetings/internal/meetingscheduler/calendar/model.go
var KnownCalendarApplicationContextKeys = /*#__PURE__*/function (KnownCalendarApplicationContextKeys) {
  KnownCalendarApplicationContextKeys["ExternalIntegration"] = "external_integration";
  KnownCalendarApplicationContextKeys["Business"] = "business_id";
  KnownCalendarApplicationContextKeys["SalesTeam"] = "sales_team_id";
  return KnownCalendarApplicationContextKeys;
}(KnownCalendarApplicationContextKeys || {});
var KnownCalendarExternalIntegrations = /*#__PURE__*/function (KnownCalendarExternalIntegrations) {
  KnownCalendarExternalIntegrations["VSalesTeam"] = "v_sales_team";
  KnownCalendarExternalIntegrations["VBusiness"] = "v_business";
  return KnownCalendarExternalIntegrations;
}(KnownCalendarExternalIntegrations || {});
function PreferencesFromApi(preferences) {
  return {
    timezone: preferences.timezone,
    meetingIntegration: preferences.meetingIntegration || MeetingSource.MEETING_SOURCE_INVALID,
    availabilityIncrement: preferences.availabilityIncrement || 0,
    bufferDurationAfterMeeting: preferences.bufferDurationAfterMeeting || 0,
    bufferDurationBeforeMeeting: preferences.bufferDurationBeforeMeeting || 0,
    noticeTime: preferences.noticeTime || 0,
    calendarSlug: preferences.calendarSlug || '',
    calendarIntegration: preferences.calendarIntegration || CalendarSource.CALENDAR_SOURCE_INVALID,
    onBoardingState: preferences.onBoardingState || OnBoardingState.COMPLETED_SETUP
  };
}

/**
 In JSON format, the Duration type is encoded as a string rather than an
 object, where the string ends in the suffix "s" (indicating seconds) and
 is preceded by the number of seconds, with nanoseconds expressed as
 fractional seconds. For example, 3 seconds with 0 nanoseconds should be
 encoded in JSON format as "3s", while 3 seconds and 1 nanosecond should
 be expressed in JSON format as "3.000000001s", and 3 seconds and 1
 microsecond should be expressed in JSON format as "3.000001s".
 https://developers.google.com/protocol-buffers/docs/reference/java/com/google/protobuf/Duration
 */
function durationFromString(durationString) {
  if (!durationString) {
    return {
      seconds: 0,
      nanoseconds: 0
    };
  }
  const [secondsString, nanosecondString] = durationString.replace(/s/g, '') // the end of the string has an s
  .split('.'); // before the decimal is seconds, after is nanoseconds
  const seconds = Number(secondsString);
  const nanoseconds = parseFloat('0.' + nanosecondString) * 1e9;
  return {
    seconds: isNaN(seconds) ? 0 : seconds,
    nanoseconds: isNaN(nanoseconds) ? 0 : nanoseconds
  };
}
function durationToString(duration) {
  if (!duration) {
    return '0s';
  }
  const seconds = duration.seconds || 0;
  const nanoseconds = duration.nanoseconds || 0;
  return `${seconds + nanoseconds / 1e9}s`;
}
function durationStringToMinutes(req) {
  const d = durationFromString(req.duration);
  const minutes = d.seconds / 60 + d.nanoseconds / 6e+10;
  if (req.round) {
    return Math.round(minutes);
  }
  return minutes;
}
function getFieldMask(req) {
  const keysToUpdate = req.updateFields || Object.keys(req.o || {});
  return new FieldMask({
    paths: keysToUpdate || []
  });
}
function newBusinessCenterApplicationContextProperties(req) {
  return {
    business_id: req.business_id,
    user_context: 'SMB'
  };
}
function newSalesCenterApplicationContextProperties(req) {
  return {
    partner_id: req.partner_id,
    market_id: req.market_id,
    user_context: 'SALES'
  };
}
function newPartnerCenterApplicationContextProperties(req) {
  return {
    partner_id: req.partner_id,
    user_context: 'PARTNER'
  };
}
function hostUserFromApi(hostUser) {
  return {
    userId: hostUser.userId || '',
    displayName: hostUser.displayName || '',
    isConfigured: hostUser.isConfigured || false,
    isConnected: hostUser.isConnected || false
  };
}
function GroupTypeToAPi(req) {
  const m = req.group;
  if (!m) {
    return {};
  }
  return {
    id: m.id || undefined,
    name: m.name || undefined,
    description: m.description || undefined,
    slug: m.slug || undefined,
    isPinned: m.isPinned || undefined,
    associations: m.associations ? m.associations.map(AssociationTypeToApi) : undefined,
    hexColor: m.hexColor || undefined
  };
}
function ServiceTypeToApi(req) {
  const m = req.service;
  if (!m) {
    return {};
  }
  return {
    id: m.id || undefined,
    name: m.name || undefined,
    description: m.description || undefined,
    slug: m.slug || undefined,
    isPinned: m.isPinned || undefined,
    associations: m.associations ? m.associations.map(AssociationTypeToApi) : undefined,
    hexColor: m.hexColor || undefined
  };
}
function AssociationTypeToApi(association) {
  return {
    id: association.id || undefined,
    name: association.name || undefined,
    eventType: association.eventType || undefined,
    identifier: association.identifier || undefined,
    isEditable: association.isEditable || false,
    creatorUserName: association.creatorUserName || undefined,
    calendarId: association.calendarId || undefined,
    hexColor: association.hexColor || undefined,
    duration: association.duration || undefined,
    description: association.description || undefined,
    bookingUrl: association.bookingUrl || undefined
  };
}
function AssociationFromApi(associationApi) {
  return {
    id: associationApi.id || '',
    name: associationApi.name || '',
    eventType: associationApi.eventType || '',
    identifier: associationApi.identifier || '',
    isEditable: associationApi.isEditable || false,
    creatorUserName: associationApi.creatorUserName || '',
    calendarId: associationApi.calendarId || '',
    hexColor: associationApi.hexColor || '',
    duration: associationApi.duration || '',
    description: associationApi.description || '',
    bookingUrl: associationApi.bookingUrl || ''
  };
}
function GroupFromApi(req) {
  const groupId = req.groupApi.id || '';
  const groupSlug = req.groupApi.slug || '';
  const bookingUrl = req?.groupApi?.bookingUrl || getBookingURL(req.environment, groupSlug, groupId);
  return {
    id: groupId,
    name: req.groupApi.name || '',
    description: req.groupApi.description || '',
    slug: groupSlug,
    isPinned: req.groupApi.isPinned || false,
    associations: req.groupApi.associations ? req.groupApi.associations.map(AssociationFromApi) : [],
    hexColor: req.groupApi.hexColor || '',
    bookingUrl: bookingUrl
  };
}
function getBookingURL(environment, slug, calendarId) {
  let bookingUrl = '';
  if (slug != '') {
    bookingUrl = getBookingUrlImplementation({
      environment: environment,
      calendarId: calendarId,
      meetingTypeSlug: slug
    });
  }
  return bookingUrl;
}
function ServiceFromApi(req) {
  const serviceId = req.serviceApi.id || '';
  const serviceSlug = req.serviceApi.slug || '';
  const bookingUrl = req?.serviceApi?.bookingUrl || getBookingURL(req.environment, serviceSlug, serviceId);
  return {
    id: req.serviceApi.id || '',
    name: req.serviceApi.name || '',
    description: req.serviceApi.description || '',
    slug: req.serviceApi.slug || '',
    isPinned: req.serviceApi.isPinned || false,
    associations: req.serviceApi.associations ? req.serviceApi.associations.map(AssociationFromApi) : [],
    hexColor: req.serviceApi.hexColor || '',
    bookingUrl: bookingUrl
  };
}
var MeetingSourceOrigin = /*#__PURE__*/function (MeetingSourceOrigin) {
  MeetingSourceOrigin["TaskManager"] = "task-manager";
  MeetingSourceOrigin["PartnerCenter"] = "partner-center";
  MeetingSourceOrigin["BusinessApp"] = "business-app";
  MeetingSourceOrigin["SalesCenter"] = "sales-center";
  return MeetingSourceOrigin;
}(MeetingSourceOrigin || {});
let GuestService = /*#__PURE__*/(() => {
  class GuestService {
    constructor(guestAPIService) {
      this.guestAPIService = guestAPIService;
    }
    getMeetingType(req) {
      return this.guestAPIService.getMeetingType(req).pipe(map(resp => {
        if (!resp || !resp.meetingType) {
          return {};
        }
        return MeetingTypeFromApi({
          environment: onProductionGlobal() ? Environment.PROD : Environment.DEMO,
          calendarId: req.calendarSlug,
          meetingTypeApi: resp.meetingType,
          metadata: req.metadata,
          calendarSlug: req.calendarSlug
        });
      }));
    }
    listMeetingTypes(req) {
      return this.guestAPIService.listMeetingTypes(req).pipe(map(resp => {
        if (!resp || !resp.meetingTypes) {
          return [];
        }
        return resp.meetingTypes.map(mt => {
          return MeetingTypeFromApi({
            environment: onProductionGlobal() ? Environment.PROD : Environment.DEMO,
            calendarId: req.hostId,
            meetingTypeApi: mt,
            metadata: req.metadata,
            calendarSlug: req.calendarSlug
          });
        });
      }));
    }
    listAvailableTimeSlots(req) {
      return this.guestAPIService.listAvailableTimeSlots(req).pipe(map(resp => resp.timeSlots ? resp.timeSlots.map(ts => TimeSpanFromApi(ts)) : []));
    }
    bookMeeting(req) {
      return this.guestAPIService.bookMeeting({
        ...req,
        attendees: req.attendees,
        formAnswers: answersToAPI(req.formAnswers)
      });
    }
    cancelMeeting(req) {
      return this.guestAPIService.cancelMeeting(req).pipe(mapTo(null));
    }
    rescheduleMeeting(req) {
      return this.guestAPIService.rescheduleMeeting(req).pipe(mapTo(null));
    }
    registerSession(req) {
      return this.guestAPIService.registerSession({
        ...req,
        attendees: req.attendees,
        formAnswers: req.formAnswers
      }).pipe(mapTo(null));
    }
    // getHost returns an individual host by their hostId
    getHost(req) {
      return this.guestAPIService.getHost(req).pipe(map(resp => HostFromApi(resp.host)));
    }
    // getCalendar returns a Calendar, which may represent an individual host OR a grouping of hosts (I.e., a team)
    getCalendar(req) {
      return this.guestAPIService.getCalendar(req).pipe(map(resp => CalendarFromApi(resp.calendar)));
    }
    getBookedMeetingInfo(meetingId, authToken) {
      return this.guestAPIService.getGuestBookedMeeting({
        meetingId: meetingId,
        authToken: authToken
      }).pipe(map(resp => ({
        start: resp.startTime,
        end: resp.endTime,
        timeZone: resp.timeZone,
        meetingTypeId: resp.meetingTypeId,
        location: resp.location,
        locationGuideline: resp.locationGuideline,
        locationType: resp.locationType,
        meetingType: resp.meetingType,
        displayName: resp.displayName,
        calendarId: resp.calendarId
      })));
    }
    isHostConfigured(req) {
      return this.guestAPIService.isHostConfigured(req).pipe(map(resp => resp.isConfigured));
    }
    getGroup(req) {
      return this.guestAPIService.getGroup(req);
    }
    getService(req) {
      return this.guestAPIService.getService(req);
    }
    getSessionMeetingInfo(req) {
      return this.guestAPIService.getSessionMeetingInfo(req);
    }
  }
  GuestService.ɵfac = function GuestService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || GuestService)(i0.ɵɵinject(MeetingGuestApiService));
  };
  GuestService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: GuestService,
    factory: GuestService.ɵfac,
    providedIn: 'root'
  });
  return GuestService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HostService = /*#__PURE__*/(() => {
  class HostService {
    constructor(hostAPIService) {
      this.hostAPIService = hostAPIService;
    }
    // Use buildHostId to get an identifier that can be used in subsequent requests. See vendastaapis for more details
    buildHostId(req) {
      return this.hostAPIService.buildHostId({
        userId: req.userId,
        // Gross typecast exists because I want to restrict the properties on the map (for now).
        applicationContextProperties: req.applicationContextProperties
      }).pipe(map(res => res.hostId || ""));
    }
    doesCalendarExist(calendarIdentifier) {
      return this.hostAPIService.doesCalendarExist({
        calendarIdentifier: calendarIdentifier
      }).pipe(map(resp => resp.exists));
    }
    getCalendar(req) {
      return this.hostAPIService.getCalendar({
        calendarId: req.calendarId
      }).pipe(map(res => CalendarFromApi(res?.calendar)));
    }
    ensurePersonalCalendarExists(req) {
      return this.hostAPIService.ensurePersonalCalendarExists({
        userId: req.userId,
        applicationContextProperties: req.applicationContextProperties
      }).pipe(map(res => res ? res.calendarId : ""));
    }
    ensureGroupCalendarsExist(req) {
      return this.hostAPIService.ensureGroupCalendarsExist({
        externalIds: req.externalIds
      }).pipe(map(res => res?.calendarIds || []));
    }
    /*
       createCalendar creates a calendar which meeting types can be created for and events can be booked on
       The fields of a calendar are documented in https://github.com/vendasta/vendastaapis/blob/master/meetings/v1/shared.proto
      */
    createCalendar(req) {
      return this.hostAPIService.createCalendar(req);
    }
    updateCalendarSlug(calendarId, newSlug) {
      return this.hostAPIService.updateCalendar({
        calendarId: calendarId,
        calendarUpdate: {
          slug: newSlug
        },
        fieldMask: {
          paths: ["slug"]
        }
      }).pipe(mapTo(undefined));
    }
    updateCalendarHostUserIDs(calendarId, replacementHostUserIds) {
      return this.hostAPIService.updateCalendar({
        calendarId: calendarId,
        calendarUpdate: {
          hostUserIds: replacementHostUserIds
        },
        fieldMask: {
          paths: ["host_user_ids"]
        }
      }).pipe(mapTo(undefined));
    }
    getMeetingTypesForCalendars(req) {
      return this.hostAPIService.getMeetingTypesForCalendars({
        calendarIds: req.calendarIds
      }).pipe(map(res => {
        if (!res?.calendarMeetingTypesMap) {
          return {};
        }
        return Object.keys(res.calendarMeetingTypesMap).reduce((calendarToMeetingTypeMap, calendarId) => {
          const meetingTypes = (res.calendarMeetingTypesMap[calendarId]?.meetingTypes || []).map(mt => MeetingTypeFromApi({
            meetingTypeApi: mt,
            environment: onProductionGlobal() ? Environment.PROD : Environment.DEMO,
            calendarId,
            metadata: req.metadata
          }));
          return {
            ...calendarToMeetingTypeMap,
            [calendarId]: meetingTypes
          };
        }, {});
      }));
    }
    /*
       listMeetingTypes returns a list of meeting types for a host
       @param hostId: An identifier for an individual host
       @param metadata: optional metadata to include on the meeting type booking link
       @param calendarSlug: used to replace hostId in the url. Use it when you are confident you know the host's slug.
          - calendarSlug IS NOT USED TO RETRIEVE MEETING TYPES, ONLY TO MAKE THE BOOKING URLS
      */
    listMeetingTypes(req) {
      return this.hostAPIService.listMeetingTypes(req).pipe(map(resp => {
        if (!resp || !resp.meetingTypes) {
          return [];
        }
        return resp.meetingTypes.map(mt => {
          return MeetingTypeFromApi({
            meetingTypeApi: mt,
            calendarId: req.hostId,
            environment: onProductionGlobal() ? Environment.PROD : Environment.DEMO,
            metadata: req.metadata,
            calendarSlug: req.calendarSlug
          });
        });
      }));
    }
    /*
       getBookingUrl returns a link that can be used to book a meeting with this host.
       @param calendarId: An identifier for an individual host or grouping of hosts (i.e., team).
       @param @deprecated hostId: An identifier for an individual host.
       @param meetingTypeId: An optional identifier for the meeting type. Default: 30-minutes.
       @param metadata: optional metadata to include in the url.
       - metadata can be used to pre-fill certain form fields and will be stored during the booking process.
       - metadata can be obtained by subscribing to the booking event.
      @param calendarSlug: used to replace hostId in the url. Use it when you are confident you know the host's slug.
       */
    getBookingUrl(req) {
      return of(getBookingUrlImplementation({
        ...req,
        calendarId: req.calendarId || req.hostId,
        environment: onProductionGlobal() ? Environment.PROD : Environment.DEMO,
        calendarSlug: req.calendarSlug
      }));
    }
    /*
       getGeneralBookingUrl returns a link that can be used to select a meeting type to book with the given calendar.
       @param calendarId: An identifier for an individual host or grouping of hosts (i.e., team).
       @param metadata: optional metadata to include in the url.
       - metadata can be used to pre-fill certain form fields and will be stored during the booking process.
       - metadata can be obtained by subscribing to the booking event.
       @param calendarSlug: used to replace hostId in the url. Use it when you are confident you know the host's slug.
       */
    getGeneralBookingUrl(req) {
      return of(getGeneralBookingUrlImplementation({
        environment: onProductionGlobal() ? Environment.PROD : Environment.DEMO,
        calendarId: req.calendarId,
        metadata: req.metadata,
        calendarSlug: req.calendarSlug
      }));
    }
    /*
       getBookingUrlsMulti returns a mapping of hosts -> event types -> booking links.
       @param calendarId: An identifier for an individual host or grouping of hosts.
       @param meetingTypeSlug: meetingTypeSlugs are passed in the form {hostId: [meetingTypeSlug1, meetingTypeSlug2]}
       @param metadata: optional metadata to include in the url.
       - metadata can be used to pre-fill certain form fields and will be stored during the booking process.
       - metadata can be obtained by subscribing to the booking event.
       @param calendarSlug: used to replace hostId in the url. Use it when you are confident you know the host's slug.
       */
    getBookingUrlsMulti(req, metadata, calendarSlug) {
      return of(Object.keys(req).reduce((hostMap, calendarId) => {
        return {
          ...hostMap,
          [calendarId]: req[calendarId].reduce((meetingTypeMap, meetingTypeSlug) => {
            return {
              ...meetingTypeMap,
              [meetingTypeSlug]: getBookingUrlImplementation({
                calendarId,
                meetingTypeSlug,
                metadata,
                environment: onProductionGlobal() ? Environment.PROD : Environment.DEMO,
                calendarSlug
              })
            };
          }, {})
        };
      }, {}));
    }
    isHostConfigured(req) {
      return this.hostAPIService.isHostConfigured(req).pipe(map(resp => resp));
    }
    setGeneralAvailability(req) {
      const apiReq = {
        ...req,
        timeZone: new TimeZone(req.timeZone)
      };
      if (req.timeSlot) {
        apiReq.timeSlot = new TimeRange(req.timeSlot);
      }
      return this.hostAPIService.setGeneralAvailability(apiReq).pipe(mapTo(null));
    }
    listBookedMeetings(req) {
      return this.hostAPIService.listBookedMeetings({
        ...req,
        pagingOptions: new PagedRequestOptions({
          cursor: req.cursor,
          pageSize: req.pageSize
        }),
        filters: new ListBookedMeetingsRequestFilters(req.filters),
        timeZone: new TimeZone(req.timeZone)
      }).pipe(map(resp => {
        const meetings = (resp.meetings || []).map(meeting => meetingFromApi(meeting));
        return new PagedResponse(meetings, resp.pagingMetadata.nextCursor, resp.pagingMetadata.hasMore);
      }));
    }
    cancelMeeting(req) {
      return this.hostAPIService.cancelMeeting({
        ...req
      }).pipe(mapTo(null));
    }
    rescheduleMeeting(req) {
      return this.hostAPIService.rescheduleMeeting({
        ...req
      }).pipe(mapTo(null));
    }
    listAvailability(req) {
      return this.hostAPIService.listAvailability(req).pipe(map(response => {
        const results = (response.availabilityRules || []).filter(Boolean).map(a => {
          return {
            hostId: a.hostId || "",
            meetingTypeId: a.meetingTypeId || "",
            day: a.day,
            timeSlot: a.timeSlot,
            timeZone: a.timeZone
          };
        });
        return new PagedResponse(results, response.metadata.nextCursor, response.metadata.hasMore);
      }));
    }
    /* updatePreferences will update the host's preferences.
     * It is guaranteed to only update the fields provided.
     * For example:
     *  updatePreferences({meetingIntegration: MeetingSource.MEETING_SOURCE_GOOGLE_MEET})
     *  will only update the preference meetingIntegration to Google Meet. Keeping the other preferences the same.
     *
     * Alternatively, you can provide a list of keys to update as the second argument.
     * For example:
     *   updatePreferences({...object with all fields}, ['meetingIntegration'])
     *   will only update the field 'meetingIntegration' to the value in preferences.
     *
     * Calling with an empty object and no keys is a no-op, or an undefined object.
     * Calling with an object containing fields not in `Preferences` or with updateFields not linked to properties in
     * `Preferences` is an error.
     */
    updatePreferences(req) {
      const fieldMask = getFieldMask({
        o: req.preferences,
        updateFields: req.updateFields
      });
      if (fieldMask.paths.length === 0) {
        return of();
      }
      return this.hostAPIService.updateHostPreferences({
        hostId: req.hostId,
        preferences: req.preferences,
        fieldMask
      }).pipe(mapTo(undefined));
    }
    getPreferences(req) {
      return this.hostAPIService.getHostPreferences({
        hostId: req.hostId
      }).pipe(map(response => PreferencesFromApi(response.preferences)));
    }
    getMeeting(meetingId, location) {
      return this.hostAPIService.getHostMeeting({
        meetingId: meetingId,
        location: location
      }).pipe(map(resp => meetingFromApi(resp.meeting)));
    }
    updateMeetingMetadata(req) {
      return this.hostAPIService.updateMeetingMetadata({
        meetingId: req.meetingId,
        metadata: req.metadata
      }).pipe(mapTo(undefined));
    }
    hostBookMeeting(req) {
      return this.hostAPIService.hostBookMeeting({
        ...req,
        attendees: req.attendees
      });
    }
    hostBookSession(req) {
      return this.hostAPIService.hostBookSession({
        ...req
      });
    }
    bookMeeting(req) {
      return this.hostAPIService.bookMeeting(req).pipe(map(resp => resp.meetingId));
    }
    // createDefaultMeetingTypes will create what Meeting Scheduler deems to be the default meeting types.
    // If the calendar already has meeting types, this is guaranteed to be a no-op.
    createDefaultMeetingTypes(req) {
      return this.hostAPIService.createDefaultMeetingTypes({
        calendarIds: req.calendarIds
      }).pipe(mapTo(undefined));
    }
    createMeetingType(req) {
      const fieldMask = getFieldMask({
        o: req.meetingType,
        updateFields: req.updateFields
      });
      if (fieldMask.paths.length === 0) {
        return of();
      }
      return this.hostAPIService.createMeetingType({
        meetingType: MeetingTypeToApi({
          meetingType: req.meetingType
        }),
        fieldMask,
        hostId: req.HostId
      }).pipe(map(res => res.id));
    }
    /* updateMeetingType will update the meeting type fields.
     * It is guaranteed to only update the fields provided.
     * For example:
     *  updateMeetingType({name: 'Onboarding'})
     *  will only update the field 'name' to 'Onboarding'. Keeping the other fields the same.
     *
     * Alternatively, you can provide a list of keys to update as the second argument.
     * For example:
     *   updateMeetingType({...object with all fields}, ['name'])
     *   will only update the field 'name' to the value passed in.
     *
     * Calling with an empty object and no keys is a no-op, or an undefined object.
     * Calling with an object containing fields not in `MeetingType` or with updateFields not linked to properties in
     * `MeetingType` is an error.
     */
    updateMeetingType(req) {
      const fieldMask = getFieldMask({
        o: req.meetingType,
        updateFields: req.updateFields
      });
      if (fieldMask.paths.length === 0) {
        return of();
      }
      return this.hostAPIService.updateMeetingType({
        id: req.id,
        meetingType: MeetingTypeToApi({
          meetingType: req.meetingType
        }),
        fieldMask,
        hostId: req.HostId
      }).pipe(mapTo(undefined));
    }
    deleteMeetingType(req) {
      return this.hostAPIService.deleteMeetingType({
        id: req.id
      }).pipe(mapTo(undefined));
    }
    getHostsForCalendar(req) {
      return this.hostAPIService.getHostsForCalendar({
        calendarId: req.calendarId
      }).pipe(map(res => {
        const hostUsers = (res.hostUsers || []).map(hostuser => {
          return hostUserFromApi(hostuser);
        });
        const availabilityRules = res.hostUserAvailabilityRule || {};
        return {
          hostUsers,
          availabilityRules
        };
      }));
    }
    IsCalendarConfigured(req) {
      return this.hostAPIService.isCalendarConfigured(req);
    }
    sendMeetingRequestEmail(req) {
      return this.hostAPIService.sendMeetingRequestEmail(req);
    }
    createService(req) {
      const fieldMask = getFieldMask({
        o: req.service,
        updateFields: req.updateFields
      });
      if (fieldMask.paths.length === 0) {
        return of();
      }
      return this.hostAPIService.createService({
        service: ServiceTypeToApi({
          service: req.service
        }),
        fieldMask,
        hostId: req.HostId
      }).pipe(map(res => res.id));
    }
    updateService(req) {
      const fieldMask = getFieldMask({
        o: req.service,
        updateFields: req.updateFields
      });
      if (fieldMask.paths.length === 0) {
        return of();
      }
      return this.hostAPIService.updateService({
        id: req.id,
        service: ServiceTypeToApi({
          service: req.service
        }),
        fieldMask,
        hostId: req.HostId
      }).pipe(mapTo(undefined));
    }
    deleteService(req) {
      return this.hostAPIService.deleteService({
        id: req.id,
        hostId: req.hostId
      }).pipe(mapTo(undefined));
    }
    listServices(req) {
      return this.hostAPIService.listServices({
        hostId: req.hostId
      }).pipe(map(res => {
        if (!res || !res.services) {
          return [];
        }
        return res.services.map(service => ServiceFromApi({
          serviceApi: service,
          environment: onProductionGlobal() ? Environment.PROD : Environment.DEMO
        }));
      }));
    }
    createGroup(req) {
      const fieldMask = getFieldMask({
        o: req.group,
        updateFields: req.updateFields
      });
      if (fieldMask.paths.length === 0) {
        return of();
      }
      return this.hostAPIService.createGroup({
        group: GroupTypeToAPi({
          group: req.group
        }),
        fieldMask,
        hostId: req.HostId
      }).pipe(map(res => res.id));
    }
    updateGroup(req) {
      const fieldMask = getFieldMask({
        o: req.group,
        updateFields: req.updateFields
      });
      if (fieldMask.paths.length === 0) {
        return of();
      }
      return this.hostAPIService.updateGroup({
        id: req.id,
        group: GroupTypeToAPi({
          group: req.group
        }),
        fieldMask,
        hostId: req.HostId
      }).pipe(mapTo(undefined));
    }
    deleteGroup(req) {
      return this.hostAPIService.deleteGroup({
        id: req.id,
        hostId: req.hostId
      }).pipe(mapTo(undefined));
    }
    listGroups(req) {
      return this.hostAPIService.listGroups({
        hostId: req.hostId
      }).pipe(map(res => {
        if (!res || !res.groups) {
          return [];
        }
        return res.groups.map(group => GroupFromApi({
          groupApi: group,
          environment: onProductionGlobal() ? Environment.PROD : Environment.DEMO
        }));
      }));
    }
    getGroup(req) {
      return this.hostAPIService.getGroup(req);
    }
    getService(req) {
      return this.hostAPIService.getService(req);
    }
    checkGroupOrServiceSlugExist(req) {
      return this.hostAPIService.checkGroupOrServiceSlugExist(req).pipe(map(res => res.exists));
    }
    getEntityAssociations(req) {
      return this.hostAPIService.getEntityAssociations(req);
    }
    ensureSessionEventCalendarsExist(req) {
      return this.hostAPIService.ensureSessionEventCalendarsExist({
        externalId: req.externalId
      }).pipe(map(res => res?.calendarId || ""));
    }
    hostDeleteAttendees(req) {
      return this.hostAPIService.hostDeleteAttendees({
        ...req
      }).pipe(mapTo(null));
    }
    listAttendees(req) {
      return this.hostAPIService.listAttendees({
        ...req
      }).pipe(mapTo(null));
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)(i0.ɵɵinject(MeetingHostApiService));
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: "root"
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { CalendarSource, CalendarType, Contact, CreateCalendarRequest, CreateCalendarResponse, DateRangeType, DayOfWeek, FormFieldType, GuestService, HostService, KnownCalendarApplicationContextKeys, KnownCalendarExternalIntegrations, MeetingLocationType, MeetingSource, MeetingSourceInfo, MeetingSourceListResponse, MeetingSourceOrigin, MeetingSourceQuery, MeetingSourceStatus, MeetingsService, OnBoardingState, PagedResponse, RegistrationCutOffUnit, RelativeTimeUnit, TeamEventMeetingType, WeekdayAvailability, WellKnownFormFieldIds, WellKnownMeetingMetadataKeys, addMetadataToBookingLink, durationFromString, durationStringToMinutes, durationToString, meetingSchedulerIdToMetadataKey, newBusinessCenterApplicationContextProperties, newPartnerCenterApplicationContextProperties, newSalesCenterApplicationContextProperties };
